import React from 'react';
import tobeor from 'tobeor';
import { cloneDeep, zipObject, get } from '../../utils/lodash';
import { connect } from 'react-redux';

import { withStyles } from '@mui/styles';

import { Tabs, Tab, Button, Divider, Paper, Popover, Table, TableBody, TableCell, TableRow, AppBar, Toolbar, IconButton } from '@mui/material';

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import Delete from '@mui/icons-material/Delete';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import ExpandMore from '@mui/icons-material/ExpandMore';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import ArrowForwardIosOutlined from '@mui/icons-material/ArrowForwardIosOutlined';
import ArrowBackIosNewOutlined from '@mui/icons-material/ArrowBackIosNewOutlined';
import Clear from '@mui/icons-material/Clear';
import Search from '@mui/icons-material/Search';

import Node from '../Node';
import LoaderNew from '../LoaderNew';
import UploadForm from '../UploadForm';
import TrplFormRow from './TrplFormRow';
import CommonStyles from '../CommonStyles';
import { NODE_TITLE, TRPL_SELECT_PLACEHOLDER } from '../../constants';
import TrplFormStyles from './TrplFormStyles';
import ComponentWrapper from '../ComponentWrapper';
import DeletedNodeAlert from '../DeletedNodeAlert';
import TrplSelect from '../TrplControls/TrplSelect';
import TrplsTable from '../TrplsTable/TrplsTable';
import TrplRenderPartsModal from './TrplRenderPartsModal';
import NestedTrplFormDialog from './NestedTrplFormDialog';
import FunctionRenderer from './TrplFormRowComponents/FunctionRenderer';
import AccordeonRenderer from './TrplFormRowComponents/AccordeonRenderer';
import MandatoryAlertIcon from './TrplFormRowComponents/MandatoryAlertIcon';

import { getJelData, updateJelsFromGetView } from '../../reducer/jelsReducer';

import {
  getTransformedNodesArrayToObj,
  findLastRstInPredicateChain,
  shouldShowTrplAsEdited,
  getChainConceptsArray,
  isObjectPredicate,
  onlyUniqueByField,
  getUrlParameter,
  trplsParamsForm,
  boxParamsTable,
  getLastRstData,
  prdcParamsTable,
  prdcParamsForm,
  getConceptRsts,
  boxParamsForm,
  nodesParams,
  onlyUnique,
} from '../../utils';

import ActionConfirmation from '../ActionConfirmation';
import produce from "immer"
import { setAutoFreeze } from "immer";

setAutoFreeze(false);

const StyledCell = ({ children, style }) => (
  <TableCell
    style={{
      borderBottom: 'none',
      padding: 0,
      ...style,
    }}
  >
    {children}
  </TableCell>
);

class TrplForm extends ComponentWrapper {
  state = {
    tab: '',
    formId: 0,
    groups: [],
    concepts: [],
    loaded: false,
    ancestorId: 0,
    mode: 'create',
    frmsByNodes: {},
    ancestorTitle: '',
    mandatoryPids: [],
    searchedRst: null,
    filteringRst: false,
    saveBtnLoading: false,
    submitOnlyForm: false,
    isMoreMenuOpened: false,
    isCloseMenuOpened: false,
    otherAncestorsInFrm: [],
    optionalFieldsInitial: {},
    accordeonRestrictions: {},
    isDeleteModalOpened: false,
    topBtnsLoaders: {
      saveLoading: false,
      saveAndCloseLoading: false,
    },
    closeBtnsLoaders: {
      discardLoading: false,
      saveAndCloseLoading: false,
    },
    data: {
      trpls: {},
    },
    formData: {
      trpls: {},
      title: '',
    },
    trplFormModal: {
      isModalOpened: false,
      modalData: {
        node: {},
        rst: {},
        trpl: {},
      },
    },
    uploadFormData: {
      rstId: '',
      fields: {},
      isOpened: false,
      acceptTypes: '',
    },
    objEditModalData: {
      type: 'edit',
      ancestor: null,
      isOpened: false,
      rstId: null,
    },
    accordeonPopover: {
      element: null,
      rst: {
        id: 0,
        title: '',
        oid: 0,
      },
    },
    loadingCloseIcon: false,
    deletedObjectTids: [],
    optionalFields: {},
    debounceTimeout: null,
    arrayOfRstChangedTrpls: [],
    disabledPointerEvents: false,
  };

  _isMounted = false;

  shouldComponentUpdate = (nextProps, nextState) => {
    return (this.state !== nextState);
  };

  componentDidMount = () => {
    const { formTitle, jels } = this.props;
    if (formTitle) document.title = `${formTitle} | Milkyweb`;

    document.addEventListener('mousedown', this.moreMenuOutsideClickListener);
    document.addEventListener('mousedown', this.closeMenuOutsideClickListener);

    const closeModalIcon = document.getElementById('close-modal');
    if (closeModalIcon) document.addEventListener('keydown', this.onKeyDownHandler);

    this.prepareData();

    // update default forms
    const formsInRedux = jels.forms;
    const defaultFormsIds = jels && jels.defaultForms && jels.defaultForms.reduce((arr, defaultJel) => {
      if (formsInRedux.includes(+defaultJel.form)) return arr;
      return [ ...arr, defaultJel.form ];
    }, []);

    if (defaultFormsIds && defaultFormsIds.length) this.props.getJelData(defaultFormsIds);

    const { groups, tabs } = this.props;

    if (tabs && tabs.length) this.setState({ tab: tabs[0] });

    if (groups)
      groups.forEach((row, rowIndex) =>
        row.forEach((groupObj, groupObjIndex) => {
          this[`group-${rowIndex}-${groupObjIndex}`] = React.createRef();
        })
      );

    this._isMounted = true;
  };

  componentWillUnmount = () => {
    if (this.state.loaded) {
      document.removeEventListener('mousedown', this.moreMenuOutsideClickListener);
      document.removeEventListener('mousedown', this.closeMenuOutsideClickListener);
      const closeModalIcon = document.getElementById('close-modal');
      if (closeModalIcon) document.removeEventListener('keydown', this.onKeyDownHandler);
    }
    this._isMounted = false;
  };

  onKeyDownHandler = (e) => {
    const { closeModal } = this.props;
    const { arrayOfRstChangedTrpls } = this.state;
    if (e.key === 'Escape') {
      if (arrayOfRstChangedTrpls.length) {
        this.setState({ isCloseMenuOpened: true });
      } else {
        closeModal();
      }
    }
  };

  setMoreMenuRef = (moreMenuNode) => {
    this.moreMenu = moreMenuNode;
  };

  moreMenuOutsideClickListener = (event) => {
    if (this.state.isMoreMenuOpened && this.moreMenu && !this.moreMenu.contains(event.target)) {
      this.setState({ isMoreMenuOpened: false });
    }
  };

  setCloseMenuRef = (closeMenuNode) => {
    this.closeMenu = closeMenuNode;
  };

  closeMenuOutsideClickListener = (event) => {
    if (this.state.isCloseMenuOpened && this.closeMenu && !this.closeMenu.contains(event.target)) {
      this.setState({ isCloseMenuOpened: false });
    }
  };

  toggleRenderPartsModal = (isModalOpened) => {
    const { trplFormModal } = this.state;

    trplFormModal.isModalOpened = isModalOpened;

    if (!isModalOpened) {
      this.getIndividuals((newData) => {
        const { data } = this.state;

        const updatedData = this.getUpdatedData({
          oldData: data,
          newData,
          ancestorId: trplFormModal.modalData.node.id,
          rstId: trplFormModal.modalData.rst.id,
        });

        this.setState({
          data: updatedData,
        });
      });
    }

    this.setState({ trplFormModal });
  };

  collectConceptsData = (data, conceptsObj, ancestorId, show_pids, isNPred) => {
    const prdcParameters = (show_pids && show_pids.length )? prdcParamsTable : prdcParamsForm;
    const collectedConcepts = [];

    Object.keys(conceptsObj).forEach(conceptId => {
      const concept = {
        id: +conceptId,
        restrictions: [],
        isNPred,
      };

      conceptsObj[conceptId].forEach(rstArray => {
        let rst = Array.isArray(rstArray) ? zipObject(prdcParameters, rstArray) : rstArray;

        if (rst.type === 'OBJECT') {
          const value =
            data.trpls[ancestorId] && data.trpls[ancestorId][rst.id]
              ? data.nodes[data.trpls[ancestorId][rst.id].oid]
              : '';

          rst.value = value;
        } else {
          const value =
            data.trpls[ancestorId] && data.trpls[ancestorId][rst.id]
              ? data.trpls[ancestorId][rst.id].val
              : '';

          rst.value = value;
        }

        if (rst.inverted === undefined) rst.inverted = false;

        const isRstInShowPids = show_pids && show_pids.length && show_pids.includes(rst.id);
        const isShowPidsAbsent = !show_pids || !show_pids.length;
        const rstAlreadyAddedToConcept = concept.restrictions.find(item => item.id === rst.id);

        if (isRstInShowPids || isShowPidsAbsent) {
          if (!rstAlreadyAddedToConcept) concept.restrictions.push(rst);
        }
      });

      collectedConcepts.push(concept);
    });

    return collectedConcepts;
  };

  mergeConceptsDuplicatesById = (concepts) => {
    const conceptsDictionary = {};

    for (const concept of concepts) {
      const conceptInDict = conceptsDictionary[concept.id];
      if (conceptInDict) {
        conceptInDict.restrictions = [
          ...conceptInDict.restrictions,
          ...concept.restrictions
        ].filter(onlyUniqueByField('id'));
      } else {
        conceptsDictionary[concept.id] = concept;
      }
    }

    return Object.values(conceptsDictionary);
  }

  prepareData = (newMode, ancestor) => {
    const { show_pids, dataForShowPids, tableNodeId, formId, jels, iId, formConceptId, formConceptsByKeys } = this.props;

    const mode = newMode || this.props.mode;
    const ancestorId = ancestor || iId || formConceptId;

    const frm = cloneDeep(jels.jelData[formId]);
    const submitOnlyForm = frm && frm.submit_only;
    const saveOnlyForm = frm && frm.save_only;

    if (mode) {
      this.setState({ mode, ancestorId, formId, submitOnlyForm, saveOnlyForm }, () => {
        let concepts = [];

        if (ancestorId) {
          if (show_pids && show_pids.length && dataForShowPids) { //this block for form opened from table cell and use table data

            this.getTrplValArr(ancestorId, show_pids[0], (trpls) => {  
              const newData = cloneDeep(dataForShowPids);
              newData.trpls = { [ancestorId]: { [show_pids[0]]: trpls } };
              
              const boxR = newData.nodes[tableNodeId] ?
                zipObject(boxParamsTable, newData.nodes[tableNodeId].box).r : {};
  
              const collectedConcepts = this.collectConceptsData(
                newData,
                boxR,
                ancestorId,
                show_pids,
                false
              );
  
              concepts = [...concepts, ...collectedConcepts];
  
              this.setState(
                {
                  data: newData,
                  concepts,
                  loaded: true,
                }
              );
            });

          } else {
            this.getIndividuals((data) => {
              const frm = cloneDeep(jels.jelData[formId]);
              let nPredsConcepts = [];

              if (data.n_preds) {
                const collectedConcepts = this.collectConceptsData(
                  data,
                  data.n_preds,
                  ancestorId,
                  show_pids,
                  true
                );

                nPredsConcepts = collectedConcepts;
              }

              let formConcepts = [];
              const formAllConceptsKeys = formConceptsByKeys ? Object.keys(formConceptsByKeys) : null;

              const { formIndividuals } = this.state;

              if (formAllConceptsKeys && formAllConceptsKeys.length && formIndividuals) {
                formAllConceptsKeys.forEach((key) => {
                  const thisAncestorIndividual = formIndividuals[key];
                  if (data.nodes[formConceptsByKeys[key]] && data.nodes[formConceptsByKeys[key]].box) {
                    const boxR = data.nodes[formConceptsByKeys[key]].box.r || {};
                    const collectedConcepts = this.collectConceptsData(
                      data,
                      boxR,
                      thisAncestorIndividual,
                      show_pids,
                      false
                    );

                    formConcepts = [ ...formConcepts, ...collectedConcepts ];
                  }
                });
              }

              if (frm || (!frm && mode === 'create')) {
                const formConcept = frm && frm.concept ? frm.concept : ancestorId;
                const boxR = data.nodes[formConcept].box.r || {};
                const collectedConcepts = this.collectConceptsData(
                  data,
                  boxR,
                  ancestorId,
                  show_pids,
                  false
                );

                concepts = [ ...concepts, ...collectedConcepts ];
                
              } else {
                const abox_bottom = data.nodes[ancestorId].box.a_bottom || [];
                abox_bottom.forEach((key) => {
                  const boxR = data.nodes[key].box.r || {};
                  const collectedConcepts = this.collectConceptsData(
                    data,
                    boxR,
                    ancestorId,
                    show_pids,
                    false
                  );

                  concepts = [ ...concepts, ...collectedConcepts ];
                });
              }

              concepts = [ ...formConcepts, ...nPredsConcepts, ...concepts ];

              let titleConcept = {
                id: 0,
                isTitle: true,
                restrictions: [],
              };

              concepts = this.mergeConceptsDuplicatesById(concepts);

              concepts.forEach((concept) => {
                concept.restrictions.forEach((rst) => {

                  if (rst.isTitle) {
                    titleConcept.id = rst.sid ? rst.sid : `${ancestorId}`;
                    titleConcept.restrictions.push(rst);
                  }
                });
              });

              if (titleConcept.restrictions.length && !nPredsConcepts.length) {
                concepts.unshift(titleConcept);
              }

              const { optionalFields } = this.state;

              let groups = frm && frm.groups;

              if (groups) {
                groups.forEach((groupArr, groupArrIndex) => {
                  groupArr.forEach((groupObj, groupObjIndex) => {
                    const groupId = `${groupArrIndex}-${groupObjIndex}`;

                    if (groupObj.type === 'accordeon') {
                      // prepare accordeons
                      const groupConceptKey = groupObj.concept_key ? groupObj.concept_key : 'concept';
                      const thisAccordeonConcept = formConceptsByKeys && formConceptsByKeys[groupConceptKey] ? formConceptsByKeys[groupConceptKey] : ancestorId;

                      this.collectAccordeonData(
                        data,
                        groupObj,
                        thisAccordeonConcept,
                        `${groupArrIndex}-${groupObjIndex}`
                      );
                    }

                    if (groupObj.items) {
                      groupObj.items.forEach((frmItem) => {
                        const itemConceptKey = frmItem.concept_key ? frmItem.concept_key : 'concept';
                        const parentConcept = formConceptsByKeys && formConceptsByKeys[itemConceptKey] ? formConceptsByKeys[itemConceptKey] : formConceptId;

                        if (frmItem.type === 'custom') {
                          const newItem = {
                            ...frmItem,
                            custom_component: frmItem.custom_component.map(row => {
                              const newRowChildren = row.children.map(column => {
                                const newColumnChildren = column.children.map(comp => {
                                  if (comp.type === 'text') return comp;
                                  const pidsToChain = frmItem.custom_pid ? [...frmItem.custom_pid, ...comp.pids] : comp.pids;
                                  const foundRst = findLastRstInPredicateChain(pidsToChain, data, parentConcept, prdcParamsForm);
                                  if (frmItem.custom_pid && foundRst) foundRst.id = comp.pids;
                                  const newComp = {
                                    ...foundRst,
                                    compType: comp.type,
                                    concept_key: frmItem.concept_key,
                                    rst_title: foundRst ? foundRst.title : '',
                                    title: comp.title ? comp.title : foundRst ? foundRst.title : '',
                                    required: comp.required === true,
                                    obj_editable: comp.obj_editable || false,
                                    obj_editable_frm: comp.obj_editable_frm || 'none',
                                    trpl_filters: comp.trpl_filters,
                                  }
                                  if (comp.renderer) newComp.renderer = comp.renderer;
                                  return newComp;
                                });
                                return { ...column, children: newColumnChildren };
                              });
                            return { ...row, children: newRowChildren };
                          })};

                          if (!groupObj.restrictions) groupObj.restrictions = [];
                          groupObj.restrictions.push(newItem);

                        } else if (frmItem.type === 'function') {
                          const findedFunc = frmItem.func && groupObj.restrictions.find((rst) => rst.func === frmItem.func);

                          if (!findedFunc) groupObj.restrictions.push(frmItem);
                        } else if (concepts) {
                          concepts.forEach((concept) => {
                            let foundRst;
                            if (Array.isArray(frmItem.pid)) {
                              foundRst = findLastRstInPredicateChain(frmItem.pid, data, +concept.id, prdcParamsForm);
                            } else {
                              foundRst = concept.restrictions.find((rst) => {
                                return +rst.id === +frmItem.pid;
                              });
                              if (foundRst && foundRst.id) foundRst.id = +foundRst.id;
                            }

                            if (frmItem.optional) {
                              if (!optionalFields[groupId]) {
                                optionalFields[groupId] = {
                                  restrictions: {},
                                  selectValue: TRPL_SELECT_PLACEHOLDER,
                                };
                              }

                              if (foundRst && !optionalFields[groupId].restrictions[frmItem.pid])
                                optionalFields[groupId].restrictions[frmItem.pid] = {
                                  ...foundRst,
                                };
                            }

                            if (foundRst) {
                              if (!groupObj.restrictions) groupObj.restrictions = [];

                              const rstInArrayIndex = groupObj.restrictions.findIndex(groupObjRst =>
                              //use stringify for properly compare rsts (can be array, number or string)
                                JSON.stringify(groupObjRst.id) === JSON.stringify(foundRst.id)
                              );

                              const newRstItem = {
                                ...foundRst,
                                rst_title: foundRst ? foundRst.title : '',
                                type: frmItem.type ? frmItem.type : foundRst.type,
                                title: frmItem.title || foundRst.title,
                                required: frmItem.required === true,
                                obj_editable: frmItem.obj_editable || false,
                                obj_editable_frm: frmItem.obj_editable_frm || 'none',
                                trpl_filters: frmItem.trpl_filters,
                              };
                              if (frmItem.renderer) newRstItem.renderer = frmItem.renderer;

                              if (rstInArrayIndex !== -1) {
                                groupObj.restrictions.splice(rstInArrayIndex, 1, newRstItem);
                              } else {
                                groupObj.restrictions.push(newRstItem);
                              }
                            }
                          });
                        } else {
                          groupObj.restrictions = [];
                        }
                      });
                    }
                  });
                });
              }

              const objTrplSids = this.collectFormObjTrplSidsWhoseTrplsOnForm(ancestorId, data);
              const otherAncestorsInFrm = [...this.state.otherAncestorsInFrm, ...objTrplSids].filter(onlyUnique);

              if (this._isMounted) {
                if (groups) this.getRequiredTrpls(data);

                this.setState(
                  {
                    data,
                    groups,
                    concepts,
                    optionalFields,
                    loaded: true,
                    searchedRst: null,
                    otherAncestorsInFrm,
                  },
                  () => {
                    this.updateNodePageTitle(ancestorId);
                  }
                );
              }
            });
          }
        } else {
          let groups;

          if (frm) groups = frm.groups;

          if (this._isMounted) {

            this.setState(
              {
                groups,
                saveOnlyForm,
                submitOnlyForm,
                loaded: true,
              }
            );
          }
        }
      });
    }
  };

  collectFormObjTrplSidsWhoseTrplsOnForm = (formIndividualId, data) => {
    const { formId, jels } = this.props;

    const formsSids = [];
    if (!formId) return formsSids;
    let formsPids = [];
    const accordeonRsts = [];
    const checkedFormIds = [];

    const collectFormsPids = (formId, nesting) => {
      if (checkedFormIds.includes(formId) && nesting > 1) return;
      checkedFormIds.push(formId);

      const frm = jels.jelData[formId];
      if (frm && frm.groups) {
        for (const row of frm.groups) {
          for (let i = 0; i < row.length; i++) {
            /*only the first group of nested form is displayed on the form*/
            if (nesting > 0 && i > 0) return;

            const group = row[i];
            if (group.items) {
              for (const item of group.items) {
                if (Array.isArray(item.pid)) {
                  if (nesting === 0) formsPids.push(...item.pid.slice(1));
                  else formsPids.push(...item.pid);
                }
              }
            }
            if (group.frmId) {
              collectFormsPids(group.frmId, nesting + 1);
            }
            if (group.restrictions) accordeonRsts.push(...group.restrictions);
          }
        }
      }
    };

    collectFormsPids(formId, 0);

    if (!formsPids.length) return formsSids;
    formsPids = formsPids.filter(onlyUnique);
    const checkedSids = [];

    const collectFormsSids = (sid, nesting) => {
      if (checkedSids.includes(sid)) return;
      checkedSids.push(sid);

      if (nesting > 0 && !formsSids.includes(sid)) {
        const conceptsRsts = [];
        const concepts = get(data.nodes[sid], ['box', 'a_bottom'], []);
        for (const conceptId of concepts) {
          const conceptRsts = getConceptRsts(conceptId, data.nodes, prdcParamsForm);
          if (conceptRsts) {
            for (const rst of conceptRsts)
              if (rst.id > 0) conceptsRsts.push(rst.id);
          }
        }
        if (formsPids.some(pid => conceptsRsts.includes(pid))) formsSids.push(sid);
      }

      const trplsBySid = data.trpls[sid];
      if (!trplsBySid) return;

      for (const rstId of Object.keys(trplsBySid)) {
        if (nesting > 0 && !formsPids.includes(+rstId)) continue;
        const trplsByRstId = trplsBySid[rstId];
        for (let i = 0; i < trplsByRstId.length; i++) {
          const trpl = trplsByRstId[i];
          /*only triples of the first node are displayed on the form*/
          if (i > 0 && !accordeonRsts.includes(trpl.pid)) break;
          if (trpl.oid) collectFormsSids(trpl.oid, nesting + 1);
        }
      }
    };

    collectFormsSids(formIndividualId, 0);

    return formsSids;
  };

  collectAccordeonData = (data, groupObj, ancestorId, groupId) => {
    const { formId, frmsByNodes, otherAncestorsInFrm, accordeonRestrictions, formIndividuals, formConceptsByKeys } = this.state;
    const { jels } = this.props;

    const accFrm = jels.jelData[groupObj.frmId];

    let groupObjRstId;
    if (groupObj.restrictions) groupObjRstId = groupObj.restrictions[0];

    if (accFrm && accFrm.groups && accFrm.groups[0] && accFrm.groups[0][0]) {
      const frmItems = accFrm.groups[0][0].items;
      const frmConcept = accFrm.concept ? accFrm.concept : ancestorId;

      if (!accordeonRestrictions[accFrm.id]) accordeonRestrictions[accFrm.id] = {};

      const { optionalFields } = this.state;

      const tempOptionalRstrs = {};

      let rboxConcept = null;
      rboxConcept = data.nodes[frmConcept] && data.nodes[frmConcept].box ? data.nodes[frmConcept].box.r : {};

      frmItems.forEach(frmItem => {
        const itemConceptKey = frmItem.concept_key ? frmItem.concept_key : 'concept';
        const parentConcept = formConceptsByKeys && itemConceptKey && formConceptsByKeys[itemConceptKey] ? formConceptsByKeys[itemConceptKey] : frmConcept;

        if (frmItem.hasOwnProperty("custom_component")) {
          const newItem = {
            ...frmItem,
            custom_component: frmItem.custom_component.map(row => {
              const newRowChildren = row.children.map(column => {
                const newColumnChildren = column.children.map(comp => {
                  if (comp.type === 'text') return comp;
                  const pidsToChain = frmItem.custom_pid && comp.pids ? [...frmItem.custom_pid, ...comp.pids] : comp.pids;
                  const foundRst = findLastRstInPredicateChain(pidsToChain, data, parentConcept, prdcParamsForm);
                  if (frmItem.custom_pid && foundRst) foundRst.id.shift(0, frmItem.custom_pid.length);
                  const newComp = {
                    ...foundRst,
                    compType: comp.type,
                    concept_key: frmItem.concept_key,
                    rst_title: foundRst ? foundRst.title : '',
                    title: comp.title ? comp.title : foundRst ? foundRst.title : '',
                    required: comp.required === true,
                    obj_editable: comp.obj_editable || false,
                    obj_editable_frm: comp.obj_editable_frm || 'none',
                    trpl_filters: comp.trpl_filters,
                  }
                  if (comp.renderer) newComp.renderer = comp.renderer;
                  return newComp;
                });
                return { ...column, children: newColumnChildren };
              });
            return { ...row, children: newRowChildren };
          })};
          accordeonRestrictions[accFrm.id][newItem.id] = newItem;
        } else {
          if (rboxConcept !== null) {
            Object.keys(rboxConcept).forEach(rboxAncestor => {
              rboxConcept[rboxAncestor].forEach(rstArray => {
                let rboxRst = zipObject(prdcParamsForm, rstArray);
                let item;
                if (Array.isArray(frmItem.pid)) {
                  item = findLastRstInPredicateChain(frmItem.pid, data, parentConcept, prdcParamsForm);
                } else {
                  if (+rboxRst.id === +frmItem.pid) item = Object.assign({}, rboxRst);
                }

                if (item && item.id) {
                  accordeonRestrictions[accFrm.id][item.id] = item;
                  if (frmItem.optional) {
                    if (!optionalFields[groupId]) {
                      optionalFields[groupId] = {};
                    }
                    if (Array.isArray(frmItem.pid)) {
                      tempOptionalRstrs[frmItem.pid] = findLastRstInPredicateChain(frmItem.pid, data, parentConcept, prdcParamsForm);
                    } else {
                      tempOptionalRstrs[frmItem.pid] = rboxRst;
                    }
                  }
                }
              });
            });
          }
        }
      });

      let objectTrpls = [];

      if (groupObj.restrictions) {
        const rstId = groupObj.restrictions[0];

        objectTrpls = data.trpls[ancestorId] && data.trpls[ancestorId][rstId] ? data.trpls[ancestorId][rstId] : [];
      }

      objectTrpls.forEach((trpl, trplIndex) => {
        let trplOid;
        
        if (trpl) {
          frmsByNodes[trpl.oid] = accFrm.id;
          trplOid = trpl.oid
        } else {
          trplOid = data.nodes[ancestorId].id;
          frmsByNodes[trplOid] = accFrm.id;
        }

        if ((trpl || trplOid) && !otherAncestorsInFrm.includes(trplOid)) {
          otherAncestorsInFrm.push(trplOid);
        }

        if (optionalFields[groupId]) {
          let optionalRsts;
          const optionalFieldsRsts = get(optionalFields, [groupId, trplOid, 'restrictions']);

          if (optionalFieldsRsts) {
            const tempOptionalRstrsCopy = cloneDeep(tempOptionalRstrs);
            for (const pid of Object.keys(optionalFieldsRsts)) {
              if (!tempOptionalRstrsCopy[pid]) continue;
              if (optionalFieldsRsts[pid].show) tempOptionalRstrsCopy[pid].show = true;
            }
            optionalRsts = tempOptionalRstrsCopy;
          } else {
            optionalRsts = { ...tempOptionalRstrs };
          }

          optionalFields[groupId][trplOid] = {
            restrictions: optionalRsts,
            selectValue: TRPL_SELECT_PLACEHOLDER
          };
        }
      });

      const { optionalFieldsInitial } = this.state;

      if (!optionalFieldsInitial[groupId]) {
        optionalFieldsInitial[groupId] = tempOptionalRstrs;
      }

      this.setState({
        frmsByNodes,
        optionalFields,
        otherAncestorsInFrm,
        optionalFieldsInitial,
        accordeonRestrictions,
      });

    } else {
      //this code needed to display full rst list (if there is no form selected in accordeon)
      let foundRst;
      let objectTrpls;

      const accordeonConceptId = ancestorId;
      
      if (groupObjRstId && accordeonConceptId)
      foundRst = getLastRstData(groupObjRstId, accordeonConceptId, data.nodes, prdcParamsForm);

      if (foundRst) {
        const thisAccordeonAllRsrs = [];
        thisAccordeonAllRsrs.push(...getConceptRsts(foundRst.oid, data.nodes, prdcParamsForm));
        accordeonRestrictions[foundRst.id] = thisAccordeonAllRsrs;
        
        objectTrpls = data.trpls[ancestorId] && data.trpls[ancestorId][foundRst.id] ? data.trpls[ancestorId][foundRst.id] : [];

        if (!Array.isArray(objectTrpls)) {
          objectTrpls = [objectTrpls];
        }
        objectTrpls.forEach((trpl, trplIndex) => {
          if (trpl && !otherAncestorsInFrm.includes(trpl.oid)) {
            otherAncestorsInFrm.push(trpl.oid);
          }
        });

      } else if (formId) {
        if (accordeonConceptId && !accordeonRestrictions[accordeonConceptId]) {
          accordeonRestrictions[accordeonConceptId] = [...getConceptRsts(accordeonConceptId, data.nodes, prdcParamsForm)];
        }
      }
  
      this.setState({
        frmsByNodes,
        otherAncestorsInFrm,
        accordeonRestrictions,
      });
    }
  };

  updateParentData = () => {
    const { updateParentData } = this.props;

    if (updateParentData) updateParentData();
  };

  getGraphFilterIdByKey = (filters, conceptKey) => {
    const conceptNumber = conceptKey.split('_')[1] || '';
    const graphFilterKey = `graph_filter_id${conceptNumber ? `_${conceptNumber}` : ''}`;
  
    if (filters.hasOwnProperty(graphFilterKey)) {
      return {[graphFilterKey]: filters[graphFilterKey]};
    } else {
      return {[graphFilterKey]: null};
    }
  };

  getIndividuals = (cb) => {
    const { ancestorId, mode, submitOnlyForm } = this.state;
    const { setup, iId, jels, initialViewId, initialNodeId, formConceptsByKeys, graphFilterIdsObj } = this.props;

    const formId = this.props.formId || this.state.formId;

    const data = {
      sorter: {
        sort_pid: getUrlParameter('sort_pid') || '',
        sort_by: getUrlParameter('sort_by') || '',
      },
      render: {
        trpl:{
          type:"o",
          params: trplsParamsForm,
        },
        node:{
          type:"a",
          params: nodesParams,
        },
        prdc:{
          type:"a",
          params: prdcParamsForm,
        },
        box:{
          type:"o",
           params: boxParamsForm,
         }
      },
    };

    if (!formId) {
      data.api_key = setup.id;
      data.filter = {};

      if (mode === 'create') {
        data.filter.do_individuals = false;
        data.filter.ancestor = ancestorId;
      } else {
        data.filter.nodes = [ancestorId];
      }

      this.postWithData({
        url: `/pnkqry3`,
        data,
        cb: (res) => {
          if (res._status === 'ok') {
            res.nodes = getTransformedNodesArrayToObj(res.nodes, nodesParams);
            console.log(res.nodes)
            if (cb) cb(res);
          } else {
            this.setState({
              topBtnsLoaders: {
                saveLoading: false,
                saveAndCloseLoading: false,
              },
              closeBtnsLoaders: {
                saveAndCloseLoading: false,
              }
            });
          }
        },
      });

    } else {
      let formIndividuals = {};
      const formData = {};

      const formConceptsByKeys = this.props.formConceptsByKeys && Object.keys(this.props.formConceptsByKeys).length ? this.props.formConceptsByKeys : { concept: ancestorId };

      Object.keys(formConceptsByKeys).forEach((conceptKey, index) => {
        if (formConceptsByKeys[conceptKey] === null) return
        const graphFilterIdByKey = graphFilterIdsObj ? this.getGraphFilterIdByKey(graphFilterIdsObj, conceptKey) : null;
        const thisConcept = formConceptsByKeys[conceptKey];
        //console.log(submitOnlyForm, 'formConceptsByKeys:', conceptKey, 'graphFilterId:', graphFilterIdByKey, 'thisConcept:', thisConcept)
      
        if (graphFilterIdByKey && !submitOnlyForm) {
          const filterKeyToDelete = (Object.keys(data)).find(key => key.includes('graph_filter'));
          if (filterKeyToDelete) delete data[filterKeyToDelete];
          const filterKey = Object.keys(graphFilterIdByKey)[0];
          const filterValue = graphFilterIdByKey[filterKey];
          data[filterKey] = filterValue;
        }

        if (mode !== 'create') {
          if (ancestorId && mode !== 'view') {
            data.filter = { nodes: [ancestorId]};
          } else if (iId) { // check in what case it works .. mode === 'view'
            data.filter = { nodes: [iId] };
          }
        }
      
        data.id = formId;

        if (this.props.graph_filter_id && this.props.formId === data.id) data.graph_filter_id = this.props.graph_filter_id;

        const isViewInRedux = jels && jels.forms.includes(formId);

        data.render.jels = !isViewInRedux;

        if (initialViewId && initialViewId !== data.id) data.initial_view = initialViewId;
        if (initialNodeId && initialNodeId !== ancestorId) data.initial_node = initialNodeId;
      
        this.postWithData({
          url: `/rest/get_view`,
          data,
          cb: (res) => {
            if (this._isMounted) {
              if (res._status === 'ok') {
                if (Object.values(formConceptsByKeys).length > 1) {
                  if (res.query) { // if multiple ancestors & graph_filter
                    formIndividuals = { ...formIndividuals, [conceptKey]: res.query[0] ? res.query[0] : null };
                    formData.nodes = { ...formData.nodes, ...res.nodes };
                    formData.trpls = formData.hasOwnProperty('trpls') ? { ...formData.trpls, ...res.trpls } : { ...res.trpls };

                    if (res.jels) this.props.updateJelsFromGetView(res.jels);

                    if (Object.keys(formIndividuals).length === Object.keys(formConceptsByKeys).length) {
                      this.setState({ ancestorId: Object.values(formIndividuals)[0], formIndividuals, mode: 'edit' });

                      formData.nodes = getTransformedNodesArrayToObj(formData.nodes, nodesParams);
                      console.log(formData.nodes)
                      if (cb) cb(formData);
                    }
                  }
                  
                } else {
                  if (res.query && res.query[0] && (this.state.ancestorId !== res.query[0])) {
                    this.setState({ ancestorId: res.query[0], mode: 'edit' });
                  }

                  if (res.jels) this.props.updateJelsFromGetView(res.jels);
                  res.nodes = getTransformedNodesArrayToObj(res.nodes, nodesParams);
                  if (cb) cb(res);
                }
                
              } else {
                this.setState({
                  topBtnsLoaders: {
                    saveLoading: false,
                    saveAndCloseLoading: false,
                  },
                  closeBtnsLoaders: {
                    saveAndCloseLoading: false,
                  },
                  disabledPointerEvents: false,
                });
              }
            }
          },
        });
      });
    }
  };

  openTrplRenderPartsModal = (rst, data) => {
    const { ancestorId } = this.state;

    const modalDataTrplArray = data.trpls[ancestorId][rst.id];
    const [modalTrpl] = modalDataTrplArray ? modalDataTrplArray : [];

    this.setState({
      trplFormModal: {
        modalData: {
          rst,
          node: data.nodes[ancestorId],
          trpl: modalTrpl,
        },
        isModalOpened: true,
      },
    });
  };

  //transfer trpls from concept to created node
  transferTemporaryDraftedTrpls = (data, ancestorId) => {
    const { mode } = this.state;

    const temporaryTrpls = mode === 'create' ? cloneDeep(data.trpls[this.state.ancestorId]) || {} : null ;

    //to put drafted trpls from concept to new created node for nested form
    let temporaryDataForState = cloneDeep(data);
    temporaryDataForState.trpls[ancestorId] = temporaryTrpls;
    //delete temporary drafted trpls to concept
    delete temporaryDataForState.trpls[this.state.ancestorId];
    
    this.setState({ data: temporaryDataForState });
  };

  onSaveTrplsClick = (cb, macro) => {
    const { data, mode, ancestorId, otherAncestorsInFrm } = this.state;

    const reqData = {
      nodes: [],
      persist: true,
    };

    this.setState({ disabledPointerEvents: true });

    if (mode === 'create') reqData.cid = ancestorId;

    if (!otherAncestorsInFrm.includes(ancestorId)) otherAncestorsInFrm.push(ancestorId);

    otherAncestorsInFrm.length && otherAncestorsInFrm.forEach(ancestor => {

      const ancestorTrplsByRst = data.trpls[ancestor] || {};

      const isTrplArrayExist = ([rstId, trplArray]) => !!trplArray;

      const toEditedTrpls = ([rstId, trplArray]) => {
        return [
          rstId,
          trplArray.filter(trpl => trpl.edited)
        ]
      };

      const removeTrplWithInvalidTidsChain = ([rstId, trplArray]) => {
        return [
          rstId,
          trplArray.filter(trpl => !trpl.tid || !trpl.tidsChain
            ? true
            : trpl.tidsChain.some(tid => trpl.tidsChain.includes(tid))
          )
        ];
      };

      const isTrplArrayNotEmpty = ([rstId, trplArray]) => trplArray.length > 0;

      const formattTrpls = ([rstId, trplArray]) => {
        return [
          rstId,
          trplArray.map(trpl => {
            let formattedTrpl = {
              val: trpl.val,
              pid: rstId,
            }
            if (trpl.tid) formattedTrpl.tid = trpl.tid;
            if (trpl.tz) formattedTrpl.tz = trpl.tz;
            if (trpl.units) formattedTrpl.units = trpl.units;

            return formattedTrpl
          })
        ]
      };

      const trpls = Object.fromEntries(
        Object.entries(ancestorTrplsByRst)
          .filter(isTrplArrayExist)
          .map(toEditedTrpls)
          .map(removeTrplWithInvalidTidsChain)
          .filter(isTrplArrayNotEmpty)
          .map(formattTrpls)
      );

      const ancestorTrplsData = {
        trpls,
      };

      if (mode === 'edit') {
        ancestorTrplsData.id = ancestor;
      } else if (mode === 'create') {
        ancestorTrplsData.title = data.nodes[ancestor] && data.nodes[ancestor].title;
      }

      if ((Object.values(trpls).length && mode === 'edit') || mode === 'create')
      reqData.nodes.push(ancestorTrplsData);
    });

    const { submitOnlyForm } = this.state;

    this.postWithData({
      url: `/rest/dataimport`,
      data: reqData,
      disableNotify: macro ? true : false,
      errorCb: () => {
        if (cb) cb();
      },
      cb: (res) => {
        if (res._status === 'ok' && !submitOnlyForm) {
          const ancestorId = mode === 'create' && res.created_nodes ? res.created_nodes[0] : this.state.ancestorId;

          if (mode === 'create' && ancestorId) {
            this.transferTemporaryDraftedTrpls(data, ancestorId);
          }

          this.setState(
            {
              arrayOfRstChangedTrpls: [],
              topBtnsLoaders: {
                saveLoading: false,
                saveAndCloseLoading: false,
              },
              saveBtnLoading: false,
            },
            () => {
              const { createNodeCb } = this.props;
  
              if (createNodeCb && mode === 'create') {
                createNodeCb(res.created_nodes[0]);
              }
              this.prepareData('edit', ancestorId);

              if (cb) cb(ancestorId);

              if (!macro) this.setState({ disabledPointerEvents: false });
            }
          );
        } else {
          if (submitOnlyForm) {
            this.setState(
              {
                saveBtnLoading: false,
                arrayOfRstChangedTrpls: [],
              }
            );
            this.prepareData('create');
          };
          this.setState(
            {
              topBtnsLoaders: {
                saveLoading: false,
                saveAndCloseLoading: false,
              },
              closeBtnsLoaders: {
                saveAndCloseLoading: false,
              },
              disabledPointerEvents: false,
            }
          );
        }

        // if (cb) cb();
      },
    });
  };

  trplSaveDataImport = (params, cb) => {
    const { data, mode } = this.state;
    const { ancestor, rstId, value, inverted, tid, errorCb, addition } = params;
    const ancestorId = ancestor ? ancestor : +this.state.ancestorId;

    const reqData = {
      persist: true,
      nodes: [],
    };

    let disableNotify = false;

    const trplObject = {
      pid: rstId,
      val: value,
    };

    if (addition && addition !== null) {
      trplObject[Object.keys(addition)[0]] = Object.values(addition)[0];
    }
    if (inverted) trplObject.inverted = inverted;
    if (tid) trplObject.tid = tid;

    const trpls = rstId ? { [rstId]: [ trplObject ]} : {};

    if (mode === 'create') {
      this.setState({ disabledPointerEvents: true });
      reqData.nodes.push({
        title: data.nodes[ancestorId].title,
        trpls,
      });

      if (!rstId) disableNotify = true;
      reqData.cid = ancestorId;
    } else {
      reqData.nodes.push({
        id: ancestorId,
        trpls,
      });
    }

    this.postWithData({
      url: `/rest/dataimport`,
      data: reqData,
      disableNotify,
      cb: (res) => {
        if (res._status === 'ok') {
          const ancestorId = mode === 'create' ? res.created_nodes[0] : this.state.ancestorId;

          if (mode === 'create') {
            this.transferTemporaryDraftedTrpls(data, ancestorId);
          }

          const { createNodeCb } = this.props;
          if (createNodeCb && res.created_nodes[0]) {
            createNodeCb(res.created_nodes[0]);
          }

          if (cb) {
            cb(ancestorId);
          }
        } else {
          if (errorCb) errorCb(false, tid || rstId);
        }
        if (this.state.disabledPointerEvents) this.setState({ disabledPointerEvents: false });
      },
    });
  };

  onAccordeonAddNewNodeClick = (ancestorId, rst, groupId, customGroupNode, cb) => {
    const { data, mode } = this.state;

    if (mode === 'create') this.setState({ disabledPointerEvents: true });

    const reqData = {
      nodes: [],
      persist: true,
    };

    reqData.cid = ancestorId;

    const formData = {
      trpls: {},
      title: data.nodes[ancestorId].title,
    };

    reqData.nodes.push(formData);

    this.postWithData({
      url: `/rest/dataimport`,
      data: reqData,
      disableNotify: true,
      cb: (res) => {
        if (res._status === 'ok') {
          const { otherAncestorsInFrm } = this.state;

          const newNodeId = res.created_nodes[0];

          otherAncestorsInFrm.push(newNodeId);

          // prepare optional fields for new node
          const { optionalFields, optionalFieldsInitial } = this.state;

          if (!optionalFields[groupId]) optionalFields[groupId] = {};

          optionalFields[groupId][newNodeId] = {
            restrictions: { ...optionalFieldsInitial[groupId] },
            selectValue: TRPL_SELECT_PLACEHOLDER,
          };

          this.setState({ otherAncestorsInFrm, optionalFields }, () => {
            if (Array.isArray(rst.id) && rst.id.length > 1) {
              const lastRstData = getLastRstData(rst.id, ancestorId, data.nodes, prdcParamsForm);
              this.createNodeCb(newNodeId, lastRstData, customGroupNode, cb);
            } else
            this.createNodeCb(newNodeId, rst, customGroupNode, cb);
          });
        } else {
          if (cb) cb();
          if (this.state.disabledPointerEvents) this.setState({ disabledPointerEvents: false });
        }
      },
      errorCb: () => {
        if (cb) cb();
        if (this.state.disabledPointerEvents) this.setState({ disabledPointerEvents: false });
      }
    });
  };

  onNodeRemoveClick = (rst, trpl, ancestor, cb) => {
    const { show_pids } = this.props;
    const rstId = Array.isArray(rst.id) ? rst.id[rst.id.length - 1] : rst.id;
    const ancestorId = ancestor || this.state.ancestorId;

    if (cb) cb(true, trpl.tid || rstId);

    this.removeTrpl(trpl.tid, () => {
      const { data, deletedObjectTids } = this.state;

      const newData = produce(data, draftData => {
        this.resetEditedValues(trpl.oid, [], draftData.trpls);
      });

      this.setState({ data: newData }, () => {
        const { data } = this.state;

        const editedTrplForReplace = { trplId: trpl.tid, nodeId: ancestorId };

        if (show_pids && show_pids.length) {
          this.getTrplValArr(ancestorId, show_pids[0], (trpls) => {
            const newData = cloneDeep(data);
            newData.trpls = { [ancestorId]: { [show_pids[0]]: trpls} };
  
            this.updateDataAfterTrplSave(newData, rst, rstId, trpl.tid, ancestorId, editedTrplForReplace, cb);
          });

        } else {
          this.getIndividuals((resData) => {
            const updatedData = this.getUpdatedData({
              oldData: data, newData: resData, ancestorId, rstId, editedTrplForReplace,
            });

            const newArrayOfRstChangedTrpls = this.removeRstsFromArrayOfRstChangedTrpls(rst, 0);

            this.setState({
              data: updatedData,
              arrayOfRstChangedTrpls: newArrayOfRstChangedTrpls,
              deletedObjectTids: deletedObjectTids.concat(trpl.tid),
            }, () => {
              if (cb) cb(false, trpl.tid || rstId);
              this.updateNodePageTitle(ancestorId);
            });
          });
        }
      });
    })
  };

  resetEditedValues = (sid, checkedSids, allTrpls) => {
    const trplsBySid = allTrpls[sid];
    if (!trplsBySid || checkedSids.includes(sid)) return;
    checkedSids.push(sid);

    for (const rstId of Object.keys(trplsBySid)) {
      const trplsByRstId = trplsBySid[rstId];
      for (const trpl of trplsByRstId) {
        if (trpl.oid) {
          this.resetEditedValues(trpl.oid, checkedSids, allTrpls);
        } else {
          if (trpl.edited) {
            trpl.val = trpl.oldVal;
            delete trpl.oldVal;
            delete trpl.edited;
          }
        }
      }
    }
  }

  updateDataOnRestoreTrpl = (dataForRequest, ancestor, rstId, cb) => {
    const { trplFormModal } = this.state;
    const ancestorId = ancestor || this.state.ancestorId;

    if (cb) cb(true, rstId);

    this.postWithData({
      url: `/rest/restore_trpl`,
      data: dataForRequest,
      cb: (data) => {
        if (data.status) {
          this.getIndividuals((newData) => {
            const { data } = this.state;

            const updatedData = this.getUpdatedData({
              oldData: data,
              newData,
              ancestorId,
            });

            this.setState({
              data: updatedData,
              trplFormModal,
            }, () => {
              if (cb) cb(false, rstId);
              this.updateNodePageTitle(ancestorId);
            });
          });
        } else {
          if (cb) cb(false, rstId);
        }
      },
    });
  };

  removeAccordeonNode = (tid, nodeId, rstId, trplIndex, conceptId, cb) => {
    this.removeTrpl(tid, () => {
      this.getIndividuals((newData) => {
        const { data, ancestorId, otherAncestorsInFrm } = this.state;
        const { formConceptId } = this.props;

        if (data.trpls[ancestorId][rstId] && Array.isArray(data.trpls[ancestorId][rstId])) {
          data.trpls[ancestorId][rstId].splice(trplIndex, 1);
        } else if (data.trpls[ancestorId][rstId] && typeof data.trpls[ancestorId][rstId] === 'object') {
          delete data.trpls[ancestorId][rstId];
        }

        const filteredOtherAncestorsInForm = otherAncestorsInFrm.filter((conceptId) => conceptId !== nodeId);

        this.setState({ otherAncestorsInFrm: filteredOtherAncestorsInForm }, () => {
          const updatedData = this.getUpdatedData({
            oldData: data,
            newData,
            ancestorId,
            rstId,
            editedTrplForReplace: { tid, nodeId: ancestorId },
          });

          const accordeonRst = getLastRstData(rstId, conceptId ? conceptId : formConceptId, data.nodes, prdcParamsForm);
          const newArrayOfRstChangedTrpls = this.removeRstsFromArrayOfRstChangedTrpls(accordeonRst, trplIndex);

          this.setState(
            {
              data: updatedData,
              arrayOfRstChangedTrpls: newArrayOfRstChangedTrpls,
            },
            () => {
              if (cb) cb();
            }
          );
        });
      });
    });
  };

  removeTrplValue = (tid, rstId, trplIndex, ancestor, groupId, rst, callbacks) => {
    const ancestorId = ancestor || this.state.ancestorId;

    if (callbacks.setLoadingTids) callbacks.setLoadingTids(true, tid || rstId);

    this.removeTrpl(tid, () => {
      const { data } = this.state;

      let trplsArray = cloneDeep(data.trpls[ancestorId][rstId]);

      if (Array.isArray(trplsArray)) {
        trplsArray.splice(trplIndex, 1);
      } else {
        trplsArray = [];
      }

      const { show_pids } = this.props;

      if (show_pids && show_pids.length) {
        this.getTrplValArr(ancestorId, show_pids[0], (trpls) => {
          const { data } = this.state;

          const newData = cloneDeep(data);
          newData.trpls = { [ancestorId]: { [show_pids[0]]: trpls} };

          this.updateDataAfterTrplSave(newData, rst, rstId, tid, ancestorId, { tid, nodeId: ancestorId }, () => {
            if (callbacks.setDeletedTrplId) callbacks.setDeletedTrplId({ [rstId]: tid });
            if (callbacks.setLoadingTids) callbacks.setLoadingTids(false, tid || rstId);
          });
        });
        
      } else {
        if (groupId) {
          const { optionalFields } = this.state;

          const pidsChainKey = Array.isArray(rst.id) ? rst.id.join(',') : rst.id;

          let accordionSid;
          if (rst.accordeonInfo) {
            if (!Array.isArray(rst.id)) {
              accordionSid = ancestor;
            } else {
              const accordionTrpl = get(data.trpls, [this.state.ancestorId, rst.accordeonInfo.rstId, rst.accordeonInfo.index]);
              if (accordionTrpl && accordionTrpl.oid) accordionSid = accordionTrpl.oid;
            }
          }

          if (get(optionalFields, [groupId, accordionSid, 'restrictions', pidsChainKey])) {

            const rstCopy = {
              ...optionalFields[groupId][accordionSid].restrictions[pidsChainKey],
            };

            rstCopy.show = false;

            optionalFields[groupId][accordionSid].restrictions[pidsChainKey] = rstCopy;

            this.setState({ optionalFields });
          } else if (get(optionalFields, [groupId, 'restrictions', pidsChainKey])) {

            const rstCopy = {
              ...optionalFields[groupId].restrictions[pidsChainKey],
            };

            rstCopy.show = false;

            optionalFields[groupId].restrictions[pidsChainKey] = rstCopy;

            this.setState({ optionalFields });
          }
        }

        this.getIndividuals((resData) => {
          const { data } = this.state;

          const updatedData = this.getUpdatedData({
            oldData: data, newData: resData, ancestorId, rstId, editedTrplForReplace: { tid, nodeId: ancestorId },
          })

          const trplsArray = (updatedData.trpls[ancestorId] && updatedData.trpls[ancestorId][rstId]) || [];

          let newArrayOfRstChangedTrpls = this.removeRstFromArrayOfRstChangedTrpls(rst, trplsArray);

          this.setState({
            data: updatedData,
            arrayOfRstChangedTrpls: newArrayOfRstChangedTrpls,
          }, () => {
            if (callbacks.setDeletedTrplId) callbacks.setDeletedTrplId({ [rstId]: tid });
            if (callbacks.setLoadingTids) callbacks.setLoadingTids(false, tid || rstId);

            this.updateNodePageTitle(ancestorId);
          });
        });
      }
    });
  };

  removeTrpl = (tid, cb) => {
    this.get({
      url: `/rest/del_trpl?id=${tid}`,
      cb: () => {
        if (cb) cb();
      },
    });
  };

  onWidgetCheckboxesValueEdit = (rst, value, trplIndex, customAncestorId) => {
    const { data, otherAncestorsInFrm } = this.state;

    const nodeId = customAncestorId || this.state.ancestorId;
    if (!otherAncestorsInFrm.includes(nodeId)) otherAncestorsInFrm.push(nodeId);
    const rstId = Array.isArray(rst.id) ? rst.id[rst.id.length - 1] : rst.id;

    let newArrayOfRstChangedTrpls = [];

    const uncheck = (trpl) => {
      trpl.subjectMaxBound = rst.subjectMaxBound;
      trpl.widgetCheckboxe = true;
      trpl.edited = true;
      trpl.pid = rstId;
      if (isObjectPredicate(rst)) {
        if (trpl.oid) {
          trpl.oldVal = trpl.oid;
          trpl.oid = '';
        } else {
          trpl.oldVal = trpl.val;
          trpl.val = '';
        }
      } else {
        trpl.oldVal = trpl.val;
        trpl.val = '';
      }
    }

    const createTrpl = (val) => {
      return {
        subjectMaxBound: rst.subjectMaxBound,
        widgetCheckboxe: true,
        edited: true,
        pid: rstId,
        oldVal: '',
        val,
      };
    }

    const newData = produce(data, draftData => {

      if (!draftData.trpls[nodeId]) draftData.trpls[nodeId] = {};

      const trplsByNode = draftData.trpls[nodeId];

      if (!trplsByNode[rstId]) trplsByNode[rstId] = [];

      let trpls = trplsByNode[rstId];

      if (trplIndex === 'all') {

        if (value === true) {
          rst.values.forEach(val => {
            let isNewTrpl;
            if (isObjectPredicate(rst)) {
              isNewTrpl = !trpls.find(trpl => +trpl.oid === +val)
                && !trpls.find(trpl => +trpl.val === +val)
                && !trpls.find(trpl => +trpl.oldVal === +val);
            } else {
              isNewTrpl = !trpls.find(trpl => trpl.val === val)
                && !trpls.find(trpl => trpl.oldVal === val);
            }

            if (isNewTrpl) {
              trpls.push(createTrpl(val));
            } else {
              trpls.forEach(trpl => {
                if (trpl.tid && trpl.edited) {
                  trpl.val = trpl.oldVal;
                  delete trpl.edited;
                }
              });
            }
          });
        } else {
          let trplsIndexToRemove = [];
          trpls.forEach((trpl, index) => {
            if (trpl.tid) uncheck(trpl);
            else trplsIndexToRemove.push(index);
          });
          if (trplsIndexToRemove.length) {
            trplsIndexToRemove.reverse().forEach(index => trpls.splice(index, 1));
          }
        }

      } else {

        const trplsWithVal = trpls.filter(t => t.val || t.oid);
        const maxBoundReached = rst.subjectMaxBound > 0 && rst.subjectMaxBound === trplsWithVal.length;

        if (trpls[trplIndex] && trpls[trplIndex].tid) {
          const trpl = trpls[trplIndex];

          if (trpl.edited) {
            if (!maxBoundReached || rst.subjectMaxBound === 1) {
              trpl.widgetCheckboxe = true;
              trpl.val = trpl.oldVal;
              delete trpl.oldVal;
              delete trpl.edited;
            }
            if (rst.subjectMaxBound === 1) trpls.length = 1;
          } else {
            uncheck(trpl);
          }

        } else {

          const isValSelected = trpls.some(trpl => trpl.val === value);

          if (isValSelected) {
            trpls.splice(trplIndex, 1);
          } else {
            if (!maxBoundReached || rst.subjectMaxBound === 1) {
              if (rst.subjectMaxBound === 1) {
                const trpl = trpls[0];
                if (trpl && trpl.tid && !trpl.edited) uncheck(trpl);
                trpls.splice(trpl && trpl.tid ? 1 : 0, 1, createTrpl(value));
              } else {
                trpls.splice(trplIndex, 0, createTrpl(value));
              }
            }
          }
        }

      }

      if (trpls.find(trpl => trpl.edited)) {
        newArrayOfRstChangedTrpls = this.addRstToArrayOfRstChangedTrpls(rst);
      } else {
        newArrayOfRstChangedTrpls = this.removeRstFromArrayOfRstChangedTrpls(rst, trpls);
      }
    });

    this.setState({
      data: newData,
      arrayOfRstChangedTrpls: newArrayOfRstChangedTrpls,
    });
  };

  onRstValueEdit = (rst, value, trplIndex, customAncestorId, tidsChain, addition) => {
    const { data, otherAncestorsInFrm } = this.state;

    const trplsNode = customAncestorId || this.state.ancestorId;
    if (!otherAncestorsInFrm.includes(trplsNode)) otherAncestorsInFrm.push(trplsNode);

    let rstId = Array.isArray(rst.id) ? rst.id[rst.id.length - 1] : rst.id;

    let newArrayOfRstChangedTrpls = [];

    const newData = produce(data, draftData => {

      if (!draftData.trpls[trplsNode]) {
        draftData.trpls[trplsNode] = {};
      }
      const ancestorTrpls = draftData.trpls[trplsNode];

      if (!ancestorTrpls[rstId]) {
        ancestorTrpls[rstId] = rst.type === 'BOOLEAN' ? [{ val: false }] : [{ val: '' }];
      }

      const trplsArray = ancestorTrpls[rstId];

      if (trplIndex === trplsArray.length) {
        const defaultVal = rst.type === 'BOOLEAN' ? { val: false } : { val: '' };
        trplsArray.push(defaultVal);
      }

      const trpl = trplsArray[trplIndex];

      if (addition) {
        if ((!trpl.oldAd || trpl.oldAd === '') && !trpl.edited) {
          if (!trpl[addition]) trpl[addition] = 'none';
          trpl.oldAd = trpl[addition];
        }

        trpl[addition] = value;
      } else {
        const isTimeRst = tobeor(rst.type, ['DATE', 'TIME', 'DATE_AND_TIME']);
        const isInteger = tobeor(rst.type, ['INTEGER', 'FLOAT']);
        if (isTimeRst) {
          const rstTomezoneDefault = rst.timezones && rst.timezones.find(zone => zone.hasOwnProperty('default'));
          const defaultTimezoneId = rstTomezoneDefault ? rstTomezoneDefault.id : '';
          if (!trpl.hasOwnProperty('oldAd') && !trpl.hasOwnProperty('tz')) trpl.tz = defaultTimezoneId;
        } else if (isInteger) {
          const rstDefaultUnitDafault = rst.units && rst.units.find(unit => unit.hasOwnProperty('default'));
          const defaultUnitId = rstDefaultUnitDafault ? rstDefaultUnitDafault.id : '';
          if (!trpl.hasOwnProperty('oldAd') && !trpl.hasOwnProperty('units')) trpl.units = defaultUnitId;
        }

        if ((!trpl.oldVal || trpl.oldVal === '') && !trpl.edited) {
          const oldVal = trpl.val;
          trpl.oldVal = oldVal;
        }

        trpl.subjectMaxBound = rst.subjectMaxBound;
        trpl.val = value;
      }

      if (shouldShowTrplAsEdited(trpl)) {
        trpl.edited = true;
        if (tidsChain) trpl.lastEditedTidsChain = tidsChain;
      } else {
        delete trpl.edited;
        delete trpl.lastEditedTidsChain;
      }
    
      if (trplsArray.find(trpl => trpl.edited)) {
        newArrayOfRstChangedTrpls = this.addRstToArrayOfRstChangedTrpls(rst);
      } else {
        newArrayOfRstChangedTrpls = this.removeRstFromArrayOfRstChangedTrpls(rst, trplsArray);
      }
    })

    this.setState({
      data: newData,
      arrayOfRstChangedTrpls: newArrayOfRstChangedTrpls,
    });
  };

  pluginRevokeAuthorization = (nodeId) => {

    this.get({
      url: `/google/oauth2/revoke?id=${nodeId}`
    });
  };

  pluginAuthorization = (nodeId) => {

    this.get({
      url: `/meta_query?meta_query=["google_oauth2"]`,
      cb: (res) => {
        const { client_id, auth_callback, scopes } = res._meta_query.google_oauth2;

        const params = new URLSearchParams({
          client_id: client_id,
          redirect_uri: auth_callback,
          response_type: "code",
          scope: scopes,
          access_type: "offline",  /*to get a refresh token*/
          prompt: "consent",  /*forces the user to manually confirm access*/
          state: nodeId, // communication channel node
        });

        const authUrl = `https://accounts.google.com/o/oauth2/auth?${params.toString()}`;

        //Redirect the user to the Google authorization URL
        window.location.href = authUrl;
      },
    });
  };

  onRstTypeBtnClick = (rst, nodeId, cb) => {
    const rstId = Array.isArray(rst.id) ? rst.id[rst.id.length - 1] : rst.id;

    if (+rstId === 2140) { // check also by var name and node ancestor (gmail auth)
      this.pluginAuthorization(nodeId);
    } else if (+rstId === 2144) { // check also by var name and node ancestor (gmail auth)
      this.pluginRevokeAuthorization(nodeId);
    } else {

    if (cb && cb.setLoadingTids) cb.setLoadingTids(true, rstId);

    this.onSaveTrplsClick(((createdNodeId) => {
      const eid = nodeId ? +nodeId : createdNodeId;

      this.postWithData({
        url: `/rest/run_macros`,
        data: {
          pid: +rstId,
          eid,
        },
        errorCb: () => {
          if (cb && cb.changeStatus) cb.changeStatus('error');
        },
        cb: (res) => {
          if (res && res._status === 'ok') {
            this.getIndividuals((newData) => {
              const { data } = this.state;
    
              const updatedData = this.getUpdatedData({
                oldData: data,
                newData,
                ancestorId: eid,
                rstId: rst.id
              });
    
              this.setState({
                data: updatedData,
                disabledPointerEvents: false
              }, () => {
                if (cb && cb.setLoadingTids) cb.setLoadingTids(false, rstId);
                if (cb && cb.changeStatus) cb.changeStatus('success');
              });
            });
          } else {
            this.setState({ disabledPointerEvents: false });
            if (cb && cb.setLoadingTids) cb.setLoadingTids(false, rstId);
            if (cb && cb.changeStatus) cb.changeStatus('error');
          }
        },
      })
    }), true)
  }
  };

  updTrpl = (params, cb) => {
    const { tid, sid, pid, oid, inverted, value, func, data, render } = params;

    const dataInStr = {
      tid: tid || undefined,
      sid: sid || '',
      pid: +pid || '',
      oid: oid || 0,
      inverted: inverted || false,
      val: value !== undefined ? value : '',
      func: func || '',
      data: data || '',
      render: render || '',
    };

    this.postWithData({
      url: `/rest/upd_trpl`,
      data: dataInStr,
      cb: (res) => {
        if (cb) cb(res);
      },
    });
  };

  addRstToArrayOfRstChangedTrpls = (rst) => {
    const arrayOfRstChangedTrpls = [...this.state.arrayOfRstChangedTrpls];

    const trplIdentifier = this.getTrplIndentifier(rst);

    if (trplIdentifier && arrayOfRstChangedTrpls.indexOf(trplIdentifier) === -1) {
      arrayOfRstChangedTrpls.push(trplIdentifier);
    }

    return arrayOfRstChangedTrpls;
  };

  removeRstFromArrayOfRstChangedTrpls = (rst, trplsArray) => {
    const arrayOfRstChangedTrpls = [...this.state.arrayOfRstChangedTrpls];

    const trplIdentifier = this.getTrplIndentifier(rst);
    const isAnyTrplEdited = trplsArray && trplsArray.find(trpl => trpl.edited);

    if (trplIdentifier && arrayOfRstChangedTrpls.includes(trplIdentifier) && !isAnyTrplEdited) {
      arrayOfRstChangedTrpls.splice(arrayOfRstChangedTrpls.indexOf(trplIdentifier), 1);
    }

    return arrayOfRstChangedTrpls;
  };

  removeRstsFromArrayOfRstChangedTrpls = (rst, trplIndex) => {
    let arrayOfRstChangedTrpls = [...this.state.arrayOfRstChangedTrpls];

    const trplIdentifier = this.getTrplIndentifier(rst);
    if (!trplIdentifier) return arrayOfRstChangedTrpls;

    return arrayOfRstChangedTrpls.filter(key => !key.startsWith(trplIdentifier + '.' + trplIndex + '_'));
  };

  getTrplIndentifier = (rst) => {
    const { data } = this.state;

    if (!rst) return;
    let rstObjArray = [];

    if (rst.accordeonInfo) {
      rstObjArray.push({ id: rst.accordeonInfo.rstId });
      if (Array.isArray(rst.id)) {
        for (let i = 0; i < rst.id.length; i++) {
          if (i === 0) rstObjArray.push({ id: rst.id[i], index: rst.accordeonInfo.index });
          else rstObjArray.push({ id: rst.id[i] });
        }
      } else rstObjArray.push({ id: rst.id, index: rst.accordeonInfo.index });
    } else {
      if (Array.isArray(rst.id)) rst.id.forEach(id => rstObjArray.push({ id: id }));
      else rstObjArray.push({ id: rst.id });
    }

    //to get main ancestor id if there is form and if not
    let ancestor = rst.sid;

    let identifier = '';

    if (rstObjArray.length === 1) {
      identifier += `${ancestor}_${rst.id}`;
    } else {
      rstObjArray.forEach((rst, index) => {
        let rstTemp = getLastRstData(rst.id, ancestor, data.nodes, prdcParamsForm);

        if (index === 0) identifier += `${ancestor}_${rst.id}`;
        else identifier += `.${rst.index ? rst.index : 0}_${ancestor}_${rst.id}`;
        if (rstTemp && rstTemp.oid) ancestor = rstTemp.oid;
      });
    }

    return identifier;
  };

  getTrplValArr = (nodeId, pid, cb) => {
    this.get({
      url: `/get_trpl_by_pid?nodeId=${nodeId}&pid=${pid}`,
      cb: (data) => {
        if (data._status === 'ok') {
          if (cb) cb(data.trpls);
        }
      },
    });
  };

  updateDataAfterTrplSave = (newData, rst, rstId, tid, formNodeId, editedTrplForReplace, cb) => {
    const { data } = this.state;

    const updatedData = this.getUpdatedData({
      oldData: data,
      newData,
      ancestorId: formNodeId,
      rstId,
      editedTrplForReplace,
    });

    const trplsArray = updatedData.trpls[formNodeId][rstId];

    let newTrplsValuesChanged = this.removeRstFromArrayOfRstChangedTrpls(rst, trplsArray);

    this.setState({
      arrayOfRstChangedTrpls: newTrplsValuesChanged,
      data: updatedData,
    }, () => {
      if (cb) cb(false, tid || rstId);
      this.updateNodePageTitle(formNodeId);
    });
  };

  setTrpl = (ancestor, rst, val, isBool, tid, cb, addition) => {
    const { mode, data } = this.state;
    const { show_pids } = this.props;

    const rstId = Array.isArray(rst.id) ? rst.id[rst.id.length - 1] : rst.id;
    const value = isBool && !val ? false : val;

    if (cb) cb(true, tid || rstId);

    this.trplSaveDataImport({ ancestor, rstId, value, tid, errorCb: cb, addition },
      (nodeId) => {
        const formNodeId = mode === 'edit' ? +ancestor : +nodeId;
        const editedTrplForReplace = { tid: tid || undefined, nodeId: formNodeId };

        if (show_pids && show_pids.length) {
          this.getTrplValArr(nodeId, rstId, (trpls) => {
            const newData = cloneDeep(data);
            newData.trpls = { [nodeId]: { [rstId]: trpls} };

            this.updateDataAfterTrplSave(newData, rst, rstId, tid, formNodeId, editedTrplForReplace, cb);
          });

        } else {
          this.setState({
              ancestorId: nodeId,
              mode: 'edit',
            }, () => {
              this.getIndividuals(newData => {
                this.updateDataAfterTrplSave(newData, rst, rstId, tid, formNodeId, editedTrplForReplace, cb);
              });
            }
          );
        }
      }
    );
  };

  updateNodePageTitle = (ancestorId) => {
    if (ancestorId) {
      const { data } = this.state;

      let nodeTitleValue = data.nodes[ancestorId] && data.nodes[ancestorId].title ? data.nodes[ancestorId].title : null;

      if (nodeTitleValue) {
        this.setState({ ancestorTitle: nodeTitleValue });

        const isNodeTitleOnPage = document.querySelector(`.${NODE_TITLE}`);

        if (isNodeTitleOnPage) isNodeTitleOnPage.innerHTML = nodeTitleValue;
      }
    }
  };

  onNodeAddDropdownElementClick = (params) => {
    const { node, cb } = params;
    const { rst } = params.props;
    const { show_pids } = this.props;
    const { otherAncestorsInFrm } = this.state;

    const ancestorId = params.props.ancestor || this.state.ancestorId;
    otherAncestorsInFrm.push(node.id);
    const rstId = (Array.isArray(rst.id)) ? rst.id[rst.id.length - 1] : rst.id;
    const ancestor = params.node.id;

    if (cb) cb(true, 0);

    this.trplSaveDataImport({
        ancestor: ancestorId,
        rstId,
        value: ancestor,
        inverted: rst && rst.inverted,
        errorCb: cb,
      }, (nodeId) => {
        this.setState({
          ancestorId: nodeId,
          otherAncestorsInFrm,
          mode: 'edit',
        }, () => {
          if (show_pids && show_pids.length) {
            const { data } = this.state;

            this.getTrplValArr(nodeId, rstId, (trpls) => {
              const newData = cloneDeep(data);
              newData.trpls = { [nodeId]: { [rstId]: trpls} };
              newData.nodes = { ...newData.nodes, [node.id]: node };
  
              this.updateDataAfterTrplSave(newData, rst, rstId, 0, nodeId, null, () => cb(false, 0));
            });
      
          } else {
            this.getIndividuals(newData => {
              const ancestorId = nodeId || this.state.ancestorId;
              const { data } = this.state;

              const updatedData = this.getUpdatedData({
                oldData: data,
                newData,
                ancestorId,
                rstId: rstId,
              });

              this.setState({
                data: updatedData,
              }, () => {
                if (cb) cb(false, 0);
                this.updateNodePageTitle(ancestorId);
              });
            });
          }
        });
      }
    );
  };

  getTrplNode = (chain, index, ancestorId) => {
    const { data } = this.state;

    let i = index;
    let ancestorTrpls = data.trpls[ancestorId];
    if (!ancestorTrpls) return;

    let trpls = ancestorTrpls[chain[i]];

    if (!trpls || trpls.length === 0) return;
    if (i !== (chain.length - 2)) {
      return this.getTrplNode(chain, i + 1, trpls[0].oid);
    } else {
      return trpls[0].oid;
    }
  };

  findTrplArray = (chain, index, ancestorId, tidsChain) => {
    const { data } = this.state;

    let i = index;
    let ancestorTrpls = data.trpls[ancestorId];
    if (!ancestorTrpls) return;

    let trpls = ancestorTrpls[chain[i]];

    if (!trpls || trpls.length === 0) return;
    if (i !== (chain.length - 1)) {
      tidsChain.push(trpls[0].tid);
      return this.findTrplArray(chain, i + 1, trpls[0].oid, tidsChain);
    } else {
      return trpls;
    }
  };

  getRstTrplsData = (item, rst, formNodeId, concept, accordeonRst, indexAccordeonRst) => {
    const { data, formIndividuals } = this.state;
    const { show_pids, formConceptsByKeys } = this.props;

    const prdcParameters = (show_pids && show_pids.length) ? prdcParamsTable : prdcParamsForm;

    const itemConceptKey = item && item.concept_key ? item.concept_key : 'concept';

    let ancestorId = formNodeId ? formNodeId : formIndividuals && formIndividuals[itemConceptKey] ? +formIndividuals[itemConceptKey] : formNodeId ? +formNodeId : this.state.ancestorId;
    const thisConcept = formConceptsByKeys && formConceptsByKeys[itemConceptKey] ? +formConceptsByKeys[itemConceptKey] : concept;
    if (!rst || !rst.id) return;

    let ancestorTrpls;
    let trplArray;
    let concepts;
    let isVirtual = false;
    const tidsChains = {};

    if (Array.isArray(rst)) rst = zipObject(prdcParameters, rst);

    const rstSid = rst && rst.sid ? rst.sid : Array.isArray(rst.id) && thisConcept ? getLastRstData(rst.id[0], +thisConcept, data.nodes, prdcParameters).sid
      : +thisConcept;

    if (rst.id !== -1) //to exclude title rsts
    concepts = getChainConceptsArray(Array.isArray(rst.id) ? rst.id : [rst.id], rstSid, data.nodes, prdcParameters, boxParamsTable);

    if (ancestorId && rst) {
      if (Array.isArray(rst.id)) {
        const tidsChainWithoutLastTid = [];
        let trpls = this.findTrplArray(rst.id, 0, ancestorId, tidsChainWithoutLastTid);
        trplArray = trpls ? trpls : [];

        for (const trpl of trplArray) {
          if (trpl.tid) tidsChains[trpl.tid] = [...tidsChainWithoutLastTid, trpl.tid];
        }
      } else {
        ancestorTrpls = data.trpls[ancestorId];
        trplArray = ancestorTrpls && ancestorTrpls[rst.id] ? ancestorTrpls[rst.id] : [];

        if (accordeonRst && indexAccordeonRst !== undefined) {
          if (trplArray.length) {
            const individualFormTrpls = data.trpls[ancestorId];
            const accordionObjectTrpl = get(individualFormTrpls, [accordeonRst, indexAccordeonRst]);
            if (accordionObjectTrpl && accordionObjectTrpl.tid) {
              for (const trpl of trplArray ) {
                if (trpl.tid) tidsChains[trpl.tid] = [accordionObjectTrpl.tid, trpl.tid];
              }
            }
          }
        } else {
          for (const trpl of trplArray ) {
            if (trpl.tid) tidsChains[trpl.tid] = [trpl.tid];
          }
        }
      }
    } else {
      trplArray = [];
    }

    if (trplArray && trplArray.length && trplArray[0].virtual) isVirtual = true;

    //TODO move to constants
    const type = rst.render_parts
        ? 'render_parts'
        : tobeor(rst.type, ['FILE', 'IMAGE'])
        ? 'file'
        : rst.type === 'BUTTON'
        ? 'button'
        : rst.type === 'URL'
        ? 'url'
        : rst.type === 'DATE_AND_TIME'
        ? 'datetime'
        : rst.type === 'DATE'
        ? 'date'
        : rst.type === 'TIME'
        ? 'time'
        : rst.type === 'BOOLEAN'
        ? 'checkbox'
        : rst.values && rst.type !== 'OBJECT'
        ? 'select'
        : rst.type === 'OBJECT'
        ? 'node'
        : tobeor(rst.type, ['GEOLOCATION', 'TELEGRAM_LOCATION'])
        ? 'location'
        : '';

    const nodeTitle = rst.type === 'OBJECT' && data.nodes[rst.oid] ? data.nodes[rst.oid].title : '';

    const title = rst.title;
    const subjectMinBound = rst.subjectMinBound;
    const subjectMaxBound = rst.subjectMaxBound;

    const isPossibleAddNewTrpl =
      rst.subjectMaxBound === 0 || trplArray.length < rst.subjectMaxBound;

    let rightsRstKey = Array.isArray(rst.id) ? rst.id.join('.') : rst.id;
    if (accordeonRst) rightsRstKey = accordeonRst + '.' + rightsRstKey;
    const nodeRulesKey = data.rights && data.rights.nodes[this.state.ancestorId];
    const nodeRightsRules = data.rights && data.rights.rules[nodeRulesKey];
    const mode = nodeRightsRules && nodeRightsRules[rightsRstKey] ? nodeRightsRules[rightsRstKey]
      : nodeRightsRules && nodeRightsRules.default ? nodeRightsRules.default : 'WRITE';

    const finalData = {
      mode,
      type,
      title,
      concepts,
      nodeTitle,
      trplArray,
      tidsChains,
      id: rst.id,
      subjectMinBound,
      subjectMaxBound,
      isPossibleAddNewTrpl,
      inverted: rst.inverted,
      isVirtual,
    };

    if (rst.values && rst.values.length) finalData.values = rst.values;

    return finalData;
  };

  updateDataOnFileUpload = () => {
    const { data, uploadFormData } = this.state;
    const ancestorId = uploadFormData.fields.eid || this.state.ancestorId;

    this.getIndividuals((newData) => {
      const updatedData = this.getUpdatedData({
        oldData: data,
        newData,
        ancestorId,
        rstId: uploadFormData.rstId,
      });

      this.setState({
        data: updatedData,
      },
      () => {
        this.updateNodePageTitle(ancestorId);
      });
    });
  };

  toggleUploadImgModal = (isOpened, fields, rst, setLoadingTids) => {
    const { mode } = this.state;

    const uploadFormData = {
      isOpened: false,
      fields: {},
      rstId: '',
      acceptTypes: '',
    };

    const rstId = Array.isArray(rst.id) ? rst.id[rst.id.length - 1] : rst.id;

    if (isOpened) {
      if (setLoadingTids) setLoadingTids(true, rstId);
      if (mode === 'create') {
        this.trplSaveDataImport({},(nodeId) => {
          fields.eid = nodeId;

          uploadFormData.acceptTypes = rst.formats;
          uploadFormData.isOpened = isOpened;
          uploadFormData.fields = fields;
          uploadFormData.rstId = rst.id;

          this.setState({ uploadFormData, ancestorId: nodeId, mode: 'edit' },
            () => {if (setLoadingTids) setLoadingTids(false, rstId)});
        })
      } else {
        uploadFormData.acceptTypes = rst.formats;
        uploadFormData.isOpened = isOpened;
        uploadFormData.fields = fields;

        this.setState({ uploadFormData },
          () => {if (setLoadingTids) setLoadingTids(false, rstId)});
      }
    } else {
      this.setState({ uploadFormData },
        () => {if (setLoadingTids) setLoadingTids(false, rstId)});
    }
  };

  deleteNode = () => {
    const { ancestorId } = this.state;

    this.setState({ loadingDeleteButton: true }, () => {
      this.postWithData({
        url: `/rest/delete_node`,
        data: { id: ancestorId },
        cb: () => {
          this.setState({ isDeleted: true, loadingDeleteButton: false, isDeleteModalOpened: false, arrayOfRstChangedTrpls: [] });
          this.updateParentData();
        },
      });
    });
  };

  toggleDeleteModal = (isDeleteModalOpened) => {
    this.setState({ isDeleteModalOpened });
  };

  toggleTableLoading = (arrIndex, groupIndex, loaded) => {
    const { groups } = this.state;

    groups[arrIndex][groupIndex].loaded = loaded;

    this.setState({ groups });
  };

  getRequiredTrpls = (data) => {
    const mandatoryPids = data.intent && data.intent.formId === this.state.formId && data.intent.requiredTrpls
      ? data.intent.requiredTrpls
      : [];
    this.setState({ mandatoryPids });
  };

  getUpdatedData = ({ oldData, newData, ancestorId, rstId, editedTrplForReplace }) => {
    const { otherAncestorsInFrm } = this.state;
    let itemRst = Array.isArray(rstId) ? rstId[rstId.length - 1] : rstId;

    const allIndividsInFrm = [+this.state.ancestorId, +ancestorId, ...otherAncestorsInFrm];
    const formConcepts = allIndividsInFrm
      .filter(onlyUnique).filter(val => val !== 0).map(val => +val);

    if (oldData.trpls && newData.trpls) {
      this.getRequiredTrpls(newData);

      formConcepts.forEach(concept => {
        const newDataConceptTrpls = newData.trpls[concept] || {};
        const oldDataConceptTrpls = oldData.trpls[concept] || {};

        const getUpdatedTrplArrayEntry = ([trplRstId, oldTrplArray]) => {

          const isTrplEditedAndNotSaved = (oldTrpl) => {
            return oldTrpl && oldTrpl.edited;
          }

          const isTrplNotForReplace = (oldTrpl) => {
            // TrplsArray can only have one trpl without tid
            // or one virtual trpl with tid === 0.
            // We should remove them if updating something without id

            const isOldVirtualOrNew = !oldTrpl.tid;

            const isTidMatchOrAbsent = editedTrplForReplace && (editedTrplForReplace.nodeId === concept) && (
              // eslint-disable-next-line
                editedTrplForReplace.tid == undefined
                  ? isOldVirtualOrNew
                  // eslint-disable-next-line
                  : (editedTrplForReplace.tid == oldTrpl.tid)
              )

            // eslint-disable-next-line
            const forReplace = trplRstId == itemRst && isTidMatchOrAbsent;

            return !forReplace;
          }

          const unsavedTrpls = oldTrplArray.filter(isTrplEditedAndNotSaved).filter(isTrplNotForReplace);

          const updatedTrplsArray = newDataConceptTrpls && newDataConceptTrpls[trplRstId] ? newDataConceptTrpls[trplRstId] : [];

          unsavedTrpls.forEach(unsavedTrpl => {
            const indexOfTrplFromBackend = updatedTrplsArray.findIndex(
              trplFromBackend => trplFromBackend.tid && trplFromBackend.tid === unsavedTrpl.tid
            );

            if (indexOfTrplFromBackend === -1 && !unsavedTrpl.tid) {
              const tooManyTrpls = !unsavedTrpl.widgetCheckboxe && updatedTrplsArray.length === unsavedTrpl.subjectMaxBound;
              
              const newEdited = updatedTrplsArray[updatedTrplsArray.length - 1];

              if (tooManyTrpls && newEdited) {
                newEdited.oldVal = newEdited.val;
                newEdited.val = unsavedTrpl.val;
                newEdited.edited = true;
              } else {
                updatedTrplsArray.push(unsavedTrpl);
              }
            } else {
              updatedTrplsArray[indexOfTrplFromBackend] = unsavedTrpl;
            }
          });

          return [trplRstId, updatedTrplsArray];
        };


        const updatedTrpls = Object.fromEntries(
          Object.entries(oldDataConceptTrpls)
            .map(getUpdatedTrplArrayEntry)
        );

        oldData.trpls[concept] = {
          ...newDataConceptTrpls,
          ...updatedTrpls,
        };

      if (!oldData.trpls[concept]) {
        oldData.trpls[concept] = newDataConceptTrpls || {};
      }
    });

      Object.keys(oldData.trpls).forEach(conceptId => {
        if (formConcepts.indexOf(+conceptId) === -1 && Object.keys(newData.trpls).indexOf(`${conceptId}`) === -1)
          delete oldData.trpls[conceptId];
      });

    } else {
      oldData.trpls = newData.trpls;
    }
    
    oldData.nodes = newData.nodes;
    if (newData.form_funcs) oldData.form_funcs = newData.form_funcs;

    if (oldData.rights && !newData.rights) {
      delete oldData.rights;
    }

    if (newData.rights) {
      oldData.rights = { ...newData.rights };
    }

    return oldData;
  };

  openObjectEditModal = (type, ancestor, rst, frmId, anotherNodeId) => {
    const { jels } = this.props;
    const { data } = this.state;
    const objEditModalData = { ...this.state.objEditModalData };

    document.removeEventListener('keydown', this.onKeyDownHandler);

    objEditModalData.type = type;
    objEditModalData.rstId = rst.id;
    objEditModalData.isOpened = true;
    objEditModalData.ancestor = ancestor;
    objEditModalData.anotherNodeId = anotherNodeId;

    let form;
    if (frmId && frmId !== 'none') form = jels.jelData[frmId];
    else {
      // if no form applied to object edit use default forms setting
      const formNodeAncestors = data.nodes[ancestor] && data.nodes[ancestor].box && data.nodes[ancestor].box.a
        ? [ ...data.nodes[ancestor].box.a, rst.oid ] : [ rst.oid ];
      const defaultFormsSettings = jels.defaultForms;

      if (defaultFormsSettings.length && formNodeAncestors && formNodeAncestors.length) {
        for (const ancestorId of formNodeAncestors) {
          const defaultConceptFormSetting = defaultFormsSettings.find(defaultSetting => +defaultSetting.concept === +ancestorId);

          if (defaultConceptFormSetting && defaultConceptFormSetting.form) form = jels.jelData[defaultConceptFormSetting.form];
        }
      }
    }

    if (form) objEditModalData.form = form;

    this.setState({ objEditModalData });
  };

  closeObjectEditModal = () => {
    this.getIndividuals((newData) => {
      const { data, objEditModalData } = this.state;

      const closeModalIcon = document.getElementById('close-modal');
      if (closeModalIcon) document.addEventListener('keydown', this.onKeyDownHandler);

      const updatedData = this.getUpdatedData({
        oldData: data,
        newData,
        ancestorId: objEditModalData.ancestor,
        rstId: objEditModalData.rstId,
      });

      this.setState({
        data: updatedData,
        objEditModalData: {
          type: 'edit',
          ancestor: null,
          isOpened: false,
        },
        loadingCloseIcon: false,
      });
    });
  };

  createNodeCb = (newNodeId, rst, customGroupNode, cb) => {
    const { ancestorId, objEditModalData, data } = this.state;
    const { formConceptId } = this.props;

    const rstId = rst ? rst.id : objEditModalData.rstId;
    const { anotherNodeId } = objEditModalData;

    const ancestor = customGroupNode || anotherNodeId || ancestorId;

    const conceptId = rst && rst.sid ? rst.sid : formConceptId; //(formId && formId !== 0 && formConceptId) ? 
    const fullRst = getLastRstData(rstId, conceptId, data.nodes, prdcParamsForm);
    const inverted = fullRst && fullRst.inverted;

    this.trplSaveDataImport({ ancestor, rstId, value: newNodeId, inverted },
      (nodeId) => {
        this.setState({
          ancestorId: nodeId,
          mode: 'edit',
        },
        () => {
          this.getIndividuals(newData => {
            const { data } = this.state;
            const updatedData = this.getUpdatedData({
              oldData: data,
              newData,
              ancestorId: nodeId,
              rstId: objEditModalData.rstId,
            });

            this.setState({
              data: updatedData,
            });
            if (this.state.disabledPointerEvents) this.setState({ disabledPointerEvents: false });

            if (cb) cb();
          });
        }
      )}
    );
  };

  onAccordeonEditClick = (trplOid, rst) => {
    this.openObjectEditModal('edit', trplOid, rst, rst.obj_editable_frm);
  };

  onAddNewAccordeonClick = (rstId, groupId, cb) => {
    const { concepts } = this.state;

    let rst = {};
    let oid;

    concepts.forEach((concept) => {
      concept.restrictions.forEach((cRst) => {
        if (+rstId === +cRst.id) {
          oid = cRst.oid;
          rst = cRst;
        }
      });
    });

    this.onAccordeonAddNewNodeClick(oid, rst, groupId, null, cb);
  };

  handleAccPopoverOpen = (event, textRst) => {
    const { concepts } = this.state;

    let foundRst;

    concepts.forEach((concept) => {
      concept.restrictions.forEach((rst) => {
        if (+rst.id === +textRst) {
          foundRst = rst;
        }
      });
    });

    this.setState({
      accordeonPopover: {
        element: event.currentTarget,
        rst: foundRst,
      },
    });
  };

  handleAccPopoverClose = () => {
    const { accordeonPopover } = this.state;

    accordeonPopover.element = null;

    this.setState({
      accordeonPopover,
    });
  };

  getAutocompleteTrpls = (rstId, value, cb) => {
    let { debounceTimeout } = this.state;

    if (debounceTimeout) clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(() => {
      this.get({
        url: `/get_trpls?pid=${rstId}&val=${value}&strict=0`,
        cb: (data) => {
          if (cb && data) cb(data);
        },
      });

      this.setState({ debounceTimeout: null });
    }, 500);

    this.setState({ debounceTimeout: debounceTimeout });
  };

  showOptionalRst = (rstId, groupId, nodeId) => {
    const { optionalFields } = this.state;

    const optionalFieldsCopy = {
      ...optionalFields,
    };

    if (nodeId) {
      const objCopy = { ...optionalFields[groupId][nodeId] };

      const rstCopy = {
        ...objCopy.restrictions[rstId],
      };

      rstCopy.show = true;

      objCopy.restrictions[rstId] = rstCopy;

      optionalFieldsCopy[groupId][nodeId] = objCopy;
    } else {
      const rstCopy = { ...optionalFieldsCopy[groupId].restrictions[rstId] };

      rstCopy.show = true;

      optionalFieldsCopy[groupId].restrictions[rstId] = rstCopy;
    }

    this.setState({
      optionalFields: optionalFieldsCopy,
    });
  };

  generateCauseDataLossArray = () => {
    const {data, ancestorId} = this.state;
    const ancestorTrpls = data.trpls[ancestorId];

    const trplsNumber = !!ancestorTrpls &&
      Object.values(ancestorTrpls)
        .flat()
        .length

    const dataLossEntity = {entityName: "triples", entityCount: trplsNumber};
    return trplsNumber ? [dataLossEntity] : []
  };

  onChangeTextereaHeight = (ref, elementKey) => {
    localStorage.setItem(elementKey, ref.current.clientHeight - 4);
  };

  onGroupCollapsing = (elementKey) => {
    if (localStorage.getItem(elementKey) === null) {
      localStorage.setItem(elementKey, 'collapsed');
      this.forceUpdate();
    } else {
      localStorage.removeItem(elementKey);
      this.forceUpdate();
    }
  };

  isIndividualOrNodeWithPredicates = () => {
    const { data, ancestorId } = this.state;

    return (ancestorId && data.nodes[ancestorId].is_individ)
      || (data.n_preds && data.n_preds[ancestorId] && Object.values(data.n_preds[ancestorId]).find(r => r.id > 0));
  };

  onSearchRst = (value) => {
    const { concepts, conceptsCache } = this.state;

    if (!value) {
      if (conceptsCache)
        this.setState({
          searchedRst: null,
          concepts: conceptsCache,
          conceptsCache: null,
        });
      return;
    }

    const originalConcepts = conceptsCache || concepts;
    const newConcepts = cloneDeep(originalConcepts);

    for (let conceptIdx in newConcepts) {
      const concept = newConcepts[+conceptIdx];
      const newRsts = [];

      for (let rstIdx in concept.restrictions) {
        const rst = concept.restrictions[+rstIdx];
        if (String(rst.id).includes(value) || (rst.title && rst.title.toLowerCase().includes(value.toLowerCase())))
          newRsts.push(rst);
      }
      concept.restrictions = newRsts;
    }

    this.setState({
      conceptsCache: originalConcepts,
      concepts: newConcepts,
    });
  };

  goToChangeTab = (direction) => {
    const { tabs } = this.props;
    const { tab, arrayOfRstChangedTrpls, submitOnlyForm } = this.state;

    const tabIndex = tabs.indexOf(tab);
    switch(direction) {
      case 'next':
        this.setState(() => ({ tab: tabs[tabIndex + 1]}));
        if (arrayOfRstChangedTrpls.length && !submitOnlyForm) this.onSaveTrplsClick();
        break;
      case 'back':
        this.setState(() => ({ tab: tabs[tabIndex - 1]}));
        if (arrayOfRstChangedTrpls.length && !submitOnlyForm) this.onSaveTrplsClick();
        break;
      default:
        break;
    }
  };

  isDisableTrplEditing = (individualId, pids) => {
    const { trpls } = this.state.data;

    if (!individualId || !pids || !Array.isArray(pids) || pids.length < 2) return;

    let count = 0;
    for (let i = 0; i < pids.length - 1; i++) {
      const trplsByIid = trpls[individualId];
      if (!trplsByIid) break;
      const trplsByPid = trplsByIid[pids[i]];
      if (!trplsByPid || !trplsByPid.length) break;
      individualId = trplsByPid[0].oid;

      count++;
    }

    return count < pids.length - 1;
  };

  getRstMetaData = (ids, cb) => {
    this.postWithData({
      url: `/rest/get_trpl`,
      data: {
        ids,
        render:{  
          trpl: {
            type: "o",
            params: [
              "upd_time",
              "creator",
              "creator_iid",
            ]
          }
        }
      },
      cb: (res) => {
        cb(res);
      },
    });
  };

  render() {
    const {
      tab,
      mode,
      data,
      groups,
      loaded,
      concepts,
      isDeleted,
      ancestorId,
      searchedRst,
      filteringRst,
      saveOnlyForm,
      mandatoryPids,
      ancestorTitle,
      saveBtnLoading,
      uploadFormData,
      topBtnsLoaders,
      optionalFields,
      submitOnlyForm,
      formIndividuals,
      loadingCloseIcon,
      closeBtnsLoaders,
      accordeonPopover,
      objEditModalData,
      isMoreMenuOpened,
      isCloseMenuOpened,
      isDeleteModalOpened,
      accordeonRestrictions,
      arrayOfRstChangedTrpls,
    } = this.state;

    const {
      tabs,
      jels,
      title,
      embed,
      setup,
      classes,
      embedType,
      show_pids,
      closeModal,
      disableTitle,
      formConceptId,
      isSearchByRst,
      disableLeftCol,
      disableSaveBtn,
      formConceptsByKeys,
    } = this.props;

    const { isModalOpened, modalData } = this.state.trplFormModal;

    const isNewNode = mode === 'create';
    const saveBtnText = submitOnlyForm ? 'Send' : 'Save';

    const isGroups = groups && groups.length;

    return (
      <div style={{ fontFamily: '"Urbanist", sans-serif !important' }} className='form-wrap-div'>
        {this.state.disabledPointerEvents ?
          <div style={{ position: 'fixed', zIndex: 10090, overflow: 'hidden', height: '100%', width: '110vw', top: '32px', left: 0, backgroundColor: '#F6F6FF', opacity: 0.3 }}/>
        : null}
        {(!embed && (closeModal)) ?
          <React.Fragment>
            <AppBar className={classes.appBar}>
              <Toolbar className={classes.toolBar}>
                <IconButton
                  id={'close-modal'}
                  disabled={loadingCloseIcon}
                  style={{
                    paddingRight: '10px',
                    width: '30px',
                  }}
                  onClick={() => {
                    if (arrayOfRstChangedTrpls.length) {
                      this.setState({ isCloseMenuOpened: true });
                    } else {
                      this.setState({ loadingCloseIcon: true }, () => closeModal());
                    }
                  }}
                  aria-label="Close"
                  className={classes.closeBtn}
                  size="large">
                  {loadingCloseIcon ? <LoaderNew color='#ffff' />
                  : <CloseOutlinedIcon style={{ fontSize: '24px', color: '#ffff' }} />}
                </IconButton>
                <h4 className={classes.nowrap}>{title}</h4>

                {this.state.formId ? (
                  <div
                    className={`${classes.ml5} ${classes.mr10}`}
                    style={{ fontSize: '12px', marginBottom: '12px', opacity: 0.5 }}
                  >
                    <span title="Form Id">{this.state.formId}</span>
                  </div>
                ) : null}

                {data.nodes && isGroups && formIndividuals && formConceptsByKeys && Object.values(formIndividuals) ? (
                  Object.keys(formIndividuals).map(nodeKey => {
                    const individOrConceptId = formIndividuals[nodeKey] ? formIndividuals[nodeKey] : formConceptsByKeys[nodeKey];
                    return (
                      <Node
                        isLink
                        size="xs"
                        key={nodeKey}
                        nodes={data.nodes}
                        nodeId={individOrConceptId}
                        className={`${classes.mr10}`}
                        node={data.nodes[individOrConceptId] ? data.nodes[individOrConceptId] : null}
                        isTransparent={isNewNode || !data.nodes[individOrConceptId]}
                        style={{
                          alignSelf: 'center',
                        }}
                      />
                  )})
                ) : data.nodes && isGroups && ancestorId ?
                  <Node
                    isLink
                    size="xs"
                    nodes={data.nodes}
                    nodeId={ancestorId}
                    className={`${classes.mr10}`}
                    node={data.nodes[ancestorId] ? data.nodes[ancestorId]
                      : this.state.formId && formConceptId ? data.nodes[formConceptId] : null}
                    isTransparent={isNewNode || !data.nodes[ancestorId]}
                    style={{
                      alignSelf: 'center',
                    }}
                  />
                : null}

                <div style={{ opacity: 0.5, display: 'flex', marginBottom: '1px'}}>
                  {this.state.ancestorId && !isNewNode ? (
                    <div className={`${classes.ml5} ${classes.mr5}`} style={{ fontSize: '12px' }}>
                      <span title="Node Id">{this.state.ancestorId}</span>
                    </div>
                  ) : null}                  
                </div>
              </Toolbar>
            </AppBar>

            {isCloseMenuOpened ?
              <div className={classes.headerCloseMenu} ref={this.setCloseMenuRef}>
                <div style={{ fontSize: 13, fontWeight: 550, margin: '10px', color: '#4C4C4C' }}>
                  <span>View contains unsaved changes</span>
                </div>
                <div className={classes.alignCenter}>
                  <Button
                    size="small"
                    disabled={closeBtnsLoaders.discardLoading}
                    style={{
                      background: `${closeBtnsLoaders.discardLoading ? '#FFFF' : ''}`,
                    }}
                    onClick={() => {
                      this.setState(
                        {
                          closeBtnsLoaders: {
                            discardLoading: true,
                            saveAndCloseLoading: false,
                          },
                        },
                        () => {
                          closeModal();
                        }
                      );
                    }}
                    className={`${classes.btn} ${classes.btnEmpty} ${classes.headerSecondaryBtn}`}
                  >
                    {closeBtnsLoaders.discardLoading ? <LoaderNew /> : 'Discard & Close'}
                  </Button>
                  <Button
                    size="small"
                    disabled={closeBtnsLoaders.saveAndCloseLoading}
                    style={{
                      color: '#fff',//'#ddfd7d',
                      background: `${closeBtnsLoaders.saveAndCloseLoading ? '#FFFF' : ''}`,
                    }}
                    onClick={() => {
                      this.setState(
                        {
                          closeBtnsLoaders: {
                            discardLoading: false,
                            saveAndCloseLoading: true,
                          },
                        },
                        () => {
                          this.onSaveTrplsClick(closeModal);
                        }
                      );
                    }}
                    className={`${classes.btn} ${classes.headerImportantBtn}`}
                  >
                    {closeBtnsLoaders.saveAndCloseLoading ? <LoaderNew />
                      : submitOnlyForm ? 'Send & Close' : 'Save & Close'}
                  </Button>
                  
                </div>
              </div>
            : null}
          </React.Fragment>
        : null}

        {ancestorId && !embed && closeModal && loaded && !isDeleted ? (
          <div className={classes.headerBtnsContainer} style={{ pointerEvents: this.state.disabledPointerEvents ? 'none' : 'auto' }}>
            {closeModal ? (
              <Button
                size="small"
                disabled={topBtnsLoaders.saveAndCloseLoading}
                style={{
                  color: '#ffff',//'#d3fa60',
                  background: `${topBtnsLoaders.saveAndCloseLoading ? '#fff' : ''}`,
                }}
                onClick={() => {
                  this.setState(
                    {
                      topBtnsLoaders: {
                        saveLoading: false,
                        saveAndCloseLoading: true,
                      },
                    },
                    () => {
                      this.onSaveTrplsClick(closeModal);
                    }
                  );
                }}
                className={`${classes.btn} ${classes.headerBtn}`}
              >
                {topBtnsLoaders.saveAndCloseLoading ? <LoaderNew /> : submitOnlyForm ? 'Send & Close' : 'Save & Close'}
              </Button>
            ) : null}

            <Button
              size="small"
              disabled={topBtnsLoaders.saveLoading}
              style={{
                color: '#ffff',//'#ddfd7d',
                background: `${topBtnsLoaders.saveLoading ? '#fff' : ''}`,
              }}
              onClick={() => {
                this.setState(
                  {
                    topBtnsLoaders: {
                      saveLoading: true,
                      saveAndCloseLoading: false,
                    },
                  },
                  () => {
                    this.onSaveTrplsClick();
                  }
                );
              }}
              className={`${classes.btn} ${classes.headerBtn}`}
            >
              {topBtnsLoaders.saveLoading ? <LoaderNew /> : submitOnlyForm ? 'Send' : 'Save'}
            </Button>

            {(submitOnlyForm || saveOnlyForm) ? null :
              <MoreVertOutlinedIcon
                style={{
                  color: '#fff',
                  position: 'relative',
                }}
                className={`${classes.pointer} ${classes.ml20}`}
                onClick={() => {
                  this.setState({ isMoreMenuOpened: true });
                }}
              />
            }

            {isMoreMenuOpened ? (
              <div className={classes.headerMoreMenu} ref={this.setMoreMenuRef}>
                {isNewNode ? null :
                  <Button
                    size="small"
                    className={classes.headerImportantBtn}
                    onClick={() => this.toggleDeleteModal(true)}>
                    <Delete style={{ fontSize: '14px', marginRight: '5px', color: '#fff' }} />
                    Delete
                  </Button>
                }
                <div style={{ margin: '0px 20px 0px 20px'}}>
                  <p>Form Id: {this.state.formId}</p>
                </div>
                <div style={{ margin: '0px 20px 0px 20px'}}>
                  <p>Node Id: {this.state.ancestorId}</p>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}

        <ActionConfirmation
          modalData={{
            open: isDeleteModalOpened,
            contentText: "Delete Node",
            contentBoldText: `#${ancestorId} ${ancestorTitle}?`,
            causeDataLoss: this.generateCauseDataLossArray(),
          }}
          acceptHandler={this.deleteNode}
          onClose={() => this.toggleDeleteModal(false)}
          loadingConfirm={this.state.loadingDeleteButton}
        />

        <UploadForm
          uploadUrl="/uploadimage"
          rst={uploadFormData.rstId}
          trpl={uploadFormData.trplId}
          fields={uploadFormData.fields}
          isOpen={uploadFormData.isOpened}
          acceptTypes={uploadFormData.acceptTypes}
          updateParentData={this.updateDataOnFileUpload}
          onClose={() => this.toggleUploadImgModal(false, {}, {id: uploadFormData.rstId})}
        />

        <TrplRenderPartsModal
          data={data}
          isOpen={isModalOpened}
          modalData={modalData}
          locations={setup.locations}
          onOpen={() => this.toggleRenderPartsModal(true)}
          onClose={() => {
            this.toggleRenderPartsModal(false);
          }}
          updateDataOnCreateTrpl={(cb) => {
            const { trplFormModal } = this.state;

            this.getIndividuals((newData) => {
              const { data } = this.state;

              const ancestorId = trplFormModal.modalData.node.id;
              const rst = trplFormModal.modalData.rst;

              const updatedData = this.getUpdatedData({
                oldData: data,
                newData,
                ancestorId,
                rstId: rst.id,
              });

              const modalDataTrplArray = newData.trpls[ancestorId][rst.id];

              [trplFormModal.modalData.trpl] = modalDataTrplArray ? modalDataTrplArray : [];

              this.setState(
                {
                  data: updatedData,
                  trplFormModal,
                },
                () => {
                  if (cb) cb();
                }
              );
            });
          }}
        />

        {objEditModalData.isOpened &&
        <NestedTrplFormDialog
          jels={jels}
          createNodeCb={this.createNodeCb}
          objEditModalData={objEditModalData}
          onSaveTrplsClick={this.onSaveTrplsClick}
          closeObjectEditModal={this.closeObjectEditModal}
          initialViewId={this.props.initialViewId || this.state.formId}
          initialNodeId={this.props.initialNodeId || this.state.ancestorId}
        />}

        {accordeonPopover.rst && accordeonPopover.rst.id ? (
          <Popover
            id="mouse-over-popover"
            className={classes.popover}
            anchorEl={accordeonPopover.element}
            open={Boolean(accordeonPopover.element)}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            onClose={this.handleAccPopoverClose}
            disableRestoreFocus
          >
            <div className={classes.rstInfoPopover}>
              <span>
                {accordeonPopover.rst.id} {accordeonPopover.rst.type}{' '}
                <a className={classes.rstConceptLink} href={`/node/${accordeonPopover.rst.oid}`}>
                  {data.nodes[accordeonPopover.rst.oid] ? data.nodes[accordeonPopover.rst.oid].title : 'No title'}
                </a>
              </span>
            </div>
          </Popover>
        ) : null}

        {isDeleted ? (
          <DeletedNodeAlert node={data.nodes[ancestorId]} />
        ) : !loaded ? (
          <div className={classes.loaderContainer}>
            <LoaderNew />
          </div>
        ) : (
          <div className={`trpl-form ${classes.justifyCenter}`}>
            {!disableLeftCol && !isGroups && ancestorId ? (
              <Node
                size="big"
                isLink
                nodeId={ancestorId}
                node={data.nodes[ancestorId]}
                nodes={data.nodes}
                style={{ marginRight: '20px' }}
              />
            ) : null}

            <div className='trpl-form-wrapper' key={ancestorId} style={{ width: `${isGroups || embed ? '100%' : '900px'}` }}>
              <Paper
                className={`${isGroups ? classes.groupMainContainer : classes.p20}`}
                style={
                  isGroups
                    ? {}
                    : embed
                    ? {
                        boxShadow: 'none',
                        padding: '0',
                      }
                    : {
                        borderRadius: '0',
                        boxShadow: '1px 2px 2px #E8E8E8',
                      }
                }
              >
                {!disableTitle && ancestorId && (!show_pids || (show_pids && !show_pids.length)) ? (
                  <div className={`${classes.alignCenter}`}>
                  
                    {isGroups && tabs && tabs.length ?
                      <div
                        style={{
                          display: 'block',
                          overflowX: 'auto',
                          overflowY: 'hidden',
                          margin: '5px 0 5px 10px',
                        }}>
                          <Tabs
                            className={classes.groupsTabs}
                            value={tab}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons={true}
                            aria-label="scrollable auto tabs"
                            onChange={(e, value) => {
                              this.setState({ tab: value });
                              if (arrayOfRstChangedTrpls.length && !submitOnlyForm) this.onSaveTrplsClick();
                            }}
                          >
                            {tabs.map((tabTitle, index) => {
                              let requiredItemsInTab = false;
                              
                              groups[index] && groups[index].forEach(group => {
                                let groupItems;
                                let accordeonRst;
                                if (group.type === 'accordeon' && group.frmId) {
                                  const frm = jels.jelData[group.frmId];
                                  groupItems = frm.groups[0][0].items;
                                  if (group.restrictions) accordeonRst = group.restrictions[0];
                                } else if (group.items.length) {
                                  groupItems = group.items;
                                }
                                groupItems && groupItems.forEach(item => {
                                  let itemRst = Array.isArray(item.pid) ? item.pid : [+item.pid];
                                  if (accordeonRst) itemRst.unshift(+accordeonRst);
                                  if (mandatoryPids.length && mandatoryPids.find(itemPid => itemPid.toString() === itemRst.toString()))
                                    requiredItemsInTab = true;
                                });
                              });

                              return (
                                <Tab
                                  key={index}
                                  value={`${tabTitle}`}
                                  label={`${tabTitle}`}
                                  icon={
                                    requiredItemsInTab ?
                                    <ErrorOutline
                                      style={{
                                        color: '#DD5900',
                                        fontSize: '17px',
                                        marginRight: '5px',
                                      }}
                                    />
                                    : null
                                  }
                                >
                                </Tab>
                              );
                            })}
                          </Tabs>                            
                        <div style={{ blockSize: 'auto', marginTop: '-3px'}}><Divider light /></div>
                      </div>
                    : null}
                  </div>
                ) : null}

                <Table
                  className={`form-groups-table ${
                    !embedType === 'accordeon' && (!show_pids || (show_pids && !show_pids.length)) ? classes.mb20 : ''
                  }`}
                  style={
                    isGroups
                      ? {
                          width: '100%',
                          display: 'flex',
                        }
                      : {}
                  }
                >
                  <TableBody className='form-groups-table-body' style={{ width: '100%' }}>
                    {isGroups ? (
                      <div style={{ margin: '0 -5px' }}>
                        {groups.map((groupArr, groupArrIndex) => {
                          let atLeastOneGroupHasWidth = false;

                          groupArr.forEach((group) => {
                            if (group.width) atLeastOneGroupHasWidth = true;
                          });

                          if (tabs && tabs.length && groupArrIndex !== tabs.indexOf(tab)) return null;

                          return (
                            <div
                              key={groupArrIndex}
                              className={`trpl-form-groups ${classes.flex} ${classes.groupContainer}`}
                              style={{
                                alignItems: 'stretch',
                                flexWrap: `${atLeastOneGroupHasWidth ? 'wrap' : 'nowrap'}`,
                              }}
                            >
                              {groupArr.map((group, groupIndex) => {
                                const groupId = `${groupArrIndex}-${groupIndex}`;
                                const groupKey = `fg${this.state.formId}.${groupArrIndex}.${groupIndex}`;
                                const isGroupOpened = localStorage.getItem(groupKey) === null;

                                const tbl = jels.jelData[group.tableId];
                                const frm = jels.jelData[group.frmId];

                                const groupConceptKey = group.concept_key ? group.concept_key : 'concept';
                                const groupParentIndividual = formIndividuals && formIndividuals[groupConceptKey] ? formIndividuals[groupConceptKey] : ancestorId;
                                const groupParentConcept = formConceptsByKeys && formConceptsByKeys[groupConceptKey] ? formConceptsByKeys[groupConceptKey] : frm ? frm.concept : formConceptId;

                                const groupIsLoaging = group.loaded !== undefined && !group.loaded;

                                // for mandatory field icon in accordeon and accordeon main data
                                let showMandatoryAlert = false;
                                let objectTrpls = [];
                                let accFrmEdit;
                                let accordeonRstData;

                                if (group.type === 'accordeon') {
                                  const includesRequiredFields = frm && frm.groups && frm.groups[0] && frm.groups[0][0]
                                    && frm.groups[0][0].items.find(item => {
                                      return (item.required === true || item.required === 'true')
                                  });

                                  accFrmEdit = jels.jelData[group.frmEditId];

                                  if (group.restrictions) {
                                    const accordeonRst = group.restrictions[0];

                                    objectTrpls = data.trpls[groupParentIndividual] ? data.trpls[groupParentIndividual][accordeonRst] : [];

                                    if (objectTrpls && !Array.isArray(objectTrpls)) {
                                      objectTrpls = [objectTrpls];
                                    }

                                    let foundRst = accordeonRst ? getLastRstData(accordeonRst, groupParentConcept, data.nodes, prdcParamsForm) : null;

                                    if (foundRst) accordeonRstData = foundRst; //this.getRstTrplsData(group, foundRst, null, foundRst.sid);

                                    if (foundRst)
                                    showMandatoryAlert =
                                      (objectTrpls && objectTrpls.length < foundRst.subjectMinBound) ||
                                      (foundRst.subjectMinBound && !objectTrpls);
                                    if (!objectTrpls && includesRequiredFields) showMandatoryAlert = true;
                                  } else {
                                    group.restrictions = [0];
                                  }
                                }

                                let optionalFieldsOptions = [];
                                const optionalFieldRstrs = get(optionalFields, [groupId, 'restrictions']);

                                if (optionalFieldRstrs) {
                                  Object.keys(optionalFieldRstrs).forEach((itemKey) => {
                                    const item = optionalFieldRstrs[itemKey];

                                    if (item && !item.show)
                                      optionalFieldsOptions.push({
                                        title: item.title,
                                        value: item.id,
                                      });
                                  });
                                }

                                let tableNodesQuery;

                                if (group.type === 'table' && group.restrictions && group.restrictions[0]) {
                                  const fullRst = getLastRstData(group.restrictions, groupParentConcept, data.nodes, prdcParamsForm);

                                  const groupRstTrpls = fullRst ? this.getRstTrplsData(group, fullRst, null, groupParentConcept) : null;

                                  tableNodesQuery = (groupRstTrpls && groupRstTrpls.trplArray) ? (groupRstTrpls.trplArray.reduce((arr, trpl) => {
                                    return [ ...arr, trpl.oid ];
                                  }, [])
                                  ) : [];
                                }

                                return (
                                  <div
                                    id={groupId}
                                    key={groupKey}
                                    style={{
                                      // width: group.width
                                      //   ? `calc(${group.width} - ${10 * (groupIndex + 2)})px`
                                      //   : `calc((100% / ${groupArr.length}) - ${groupArr.length * 10})px`,
                                      // width: `${
                                      //   group.width
                                      //     ? `calc(${group.width} - ${groupIndex + 1 * 10})`
                                      //     : `calc(100% / ${groupArr.length} - 20px)`
                                      // }`,
                                      zIndex: 0,
                                      width: `${
                                        group.width
                                          ? `calc(${group.width} - 22px)`
                                          : `calc(100% / ${groupArr.length} - 22px)`
                                      }`,
                                      margin: '5px',
                                      height: isGroupOpened ? `${group.height ? `calc(${group.height} - 50px)` : ''}` : 'fit-content',
                                      backgroundColor: group.type === 'accordeon' && isGroupOpened ? '#ffffff70' : '#ffffffc9',
                                      boxShadow: 'rgb(183 172 212 / 10%) 0px 1px 2px',
                                      padding: '5px',//group.title ? (group.type === 'accordeon' ? '0 5px 5px' : '0 5px 5px') : '5px',
                                      borderRadius: '12px',
                                      flexShrink: `${atLeastOneGroupHasWidth ? 0 : 'auto'}`,
                                      //height: `${group.height ? `calc(${group.height} - 50px)` : ''}`,
                                      overflow: `${group.type === 'table' ? 'hidden' : 'visible'}`,
                                      boxShadow: `${embedType === 'accordeon' ? 'nonegroup.restrictions' : ''}`,
                                      position: 'relative',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      '&:hover': {
                                        backgroundColor: '#fff',
                                      },
                                    }}
                                  >
                                    {group.title ? (
                                      <div className={`${classes.alignCenter} ${classes.groupHeading}`}>
                                        <div
                                          style={{ display: 'contents' }}
                                          onClick={() => this.onGroupCollapsing(groupKey)}
                                          className={`${classes.pointer}`}>
                                          <ExpandMore
                                            style={{
                                              marginRight: '10px',
                                              borderRadius: '12px',
                                              backgroundColor: isGroupOpened ? '' : '#E8EAF6',
                                              transform: `${isGroupOpened ? '' : 'rotate(270deg)'}`,
                                            }}
                                          />
                                        </div>
                                        <div>
                                          {group.type === 'accordeon' ? (
                                            <div className={classes.flex}>
                                              <span
                                                className={classes.pointer}
                                                onClick={(e) => this.handleAccPopoverOpen(e, group.restrictions[0])}
                                              >
                                                {group.title}
                                              </span>

                                              {showMandatoryAlert ? <MandatoryAlertIcon tooltipText={'Includes mandatory fields'}/> : null}
                                            </div>
                                          ) : (
                                            <span>{group.title}</span>
                                          )}
                                        </div>
                                      </div>
                                    ) : null}

                                    {groupIsLoaging ? (
                                      <div className={classes.groupLoaderOverlay}>
                                        <LoaderNew />
                                      </div>
                                    ) : null}

                                    {group.type === 'table' && (tbl || group.settings) && isGroupOpened ? (
                                      <div
                                        ref={this[`group-${groupArrIndex}-${groupIndex}`]}
                                        className={`trplfrm-${groupArrIndex}-${groupIndex} ${classes.groupScrollableContainer}`}
                                      >
                                        <Table>
                                          <TableBody>
                                            <TrplsTable
                                              isEmbed
                                              smallHeadingBtns={true}
                                              usePreloadedQuery={tableNodesQuery ? true : false}
                                              tableGroupIndex={groupId}
                                              height={group.height || '50vh'}
                                              settings={tbl || group.settings}
                                              trplFormGroupTitle={group.title}
                                              initialViewId={this.props.initialViewId || this.state.formId}
                                              groupContainerClassName={`trplfrm-${groupArrIndex}-${groupIndex}`}
                                              containerWidth={group.width}
                                              tableStartLoadCb={() =>
                                                this.toggleTableLoading(groupArrIndex, groupIndex, false)
                                              }
                                              tableEndLoadCb={() =>
                                                this.toggleTableLoading(groupArrIndex, groupIndex, true)
                                              }
                                              preloadedData={tableNodesQuery ?
                                                {
                                                  ...data,
                                                  total_query: tableNodesQuery.length,
                                                  query: tableNodesQuery,
                                                } : null
                                              }
                                            />
                                          </TableBody>
                                        </Table>
                                      </div>
                                    ) : group.type === 'table' && !(tbl || group.settings) ? (
                                      <div className={`${classes.justifyCenter} ${classes.mt120}`} style={{ width: '100%', color: '#878787' }}>
                                        <span>No selected table</span>
                                      </div>
                                    ) : group.type === 'table' && !isGroupOpened ? (
                                      null
                                    ) : isGroupOpened ? (
                                      <div
                                        className='trpl-form-group-opened'
                                        style={{
                                          height: `${group.height ? `calc(${group.height} - 51px - 100px)` : '100%'}`,
                                          overflow: 'initial',
                                        }}
                                      >
                                        <Table className='trpl-form-table'>
                                          <TableBody className='trpl-form-table-body'>
                                            {group.restrictions
                                              ? group.restrictions.map((rst, rstIndex) => {
                                                const item = group.items && group.items[rstIndex];
                                                if (item && item.pid) rst.id = item.pid;

                                                const itemConceptKey = item && item.concept_key ? item.concept_key : 'concept';
                                                const parentIndividual = formIndividuals && formIndividuals[itemConceptKey] ? formIndividuals[itemConceptKey] : ancestorId;
                                                const parentConcept = formConceptsByKeys && formConceptsByKeys[itemConceptKey] ? formConceptsByKeys[itemConceptKey] : frm ? frm.concept : this.props.formConceptId;

                                                  const optionalFieldRst = get(optionalFields, [
                                                    groupId,
                                                    'restrictions',
                                                    rst.id,
                                                  ]);

                                                  if (optionalFieldRst && !optionalFieldRst.show)
                                                    return null;

                                                  if (optionalFieldRst) {
                                                    const findedOptionIndex = optionalFieldsOptions.findIndex(
                                                      (option) => +option.value === rst.id
                                                    );

                                                    if (findedOptionIndex !== -1)
                                                      optionalFieldsOptions.splice(findedOptionIndex, 1);
                                                  }

                                                  if (
                                                    group.type === 'accordeon' &&
                                                    (!group.frmId || group.frmId === 'none')
                                                  ) {
 
                                                    return (

                                                      <AccordeonRenderer
                                                        rst={rst}
                                                        data={data}
                                                        item={item}
                                                        mode={mode}
                                                        key={rstIndex}
                                                        classes={classes}
                                                        groupId={groupId}
                                                        concepts={concepts}
                                                        isNewNode={isNewNode}
                                                        accFrmEdit={accFrmEdit}
                                                        setTrpl={this.setTrpl}
                                                        objectTrpls={objectTrpls}
                                                        formId={this.state.formId}
                                                        saveOnlyForm={saveOnlyForm}
                                                        concept={groupParentConcept}
                                                        getTrplNode={this.getTrplNode}
                                                        optionalFields={optionalFields}
                                                        submitOnlyForm={submitOnlyForm}
                                                        formIndividuals={formIndividuals}
                                                        formConceptsByKeys={formConceptsByKeys}
                                                        mainFormNodeId={groupParentIndividual}
                                                        accordeonRstData={accordeonRstData}
                                                        onRstValueEdit={this.onRstValueEdit}
                                                        getRstMetaData={this.getRstMetaData}
                                                        showOptionalRst={this.showOptionalRst}
                                                        removeTrplValue={this.removeTrplValue}
                                                        getRstTrplsData={this.getRstTrplsData}
                                                        onNodeRemoveClick={this.onNodeRemoveClick}
                                                        onRstTypeBtnClick={this.onRstTypeBtnClick}
                                                        accordeonRestrictions={accordeonRestrictions}
                                                        openObjectEditModal={this.openObjectEditModal}
                                                        removeAccordeonNode={this.removeAccordeonNode}
                                                        toggleUploadImgModal={this.toggleUploadImgModal}
                                                        getAutocompleteTrpls={this.getAutocompleteTrpls}
                                                        onAccordeonEditClick={this.onAccordeonEditClick}
                                                        onChangeTextereaHeight={this.onChangeTextereaHeight}
                                                        onAddNewAccordeonClick={this.onAddNewAccordeonClick}
                                                        updateDataOnRestoreTrpl={this.updateDataOnRestoreTrpl}
                                                        openTrplRenderPartsModal={this.openTrplRenderPartsModal}
                                                        onWidgetCheckboxesValueEdit={this.onWidgetCheckboxesValueEdit}
                                                        onNodeAddDropdownElementClick={
                                                          this.onNodeAddDropdownElementClick
                                                        }
                                                      />
                                                    );
                                                  }

                                                  if (group.type === 'accordeon' && frm) {

                                                    return (

                                                      <AccordeonRenderer
                                                        rst={rst}
                                                        frm={frm}
                                                        data={data}
                                                        mode={mode}
                                                        item={item}
                                                        classes={classes}
                                                        groupId={groupId}
                                                        concepts={concepts}
                                                        isNewNode={isNewNode}
                                                        setTrpl={this.setTrpl}
                                                        accFrmEdit={accFrmEdit}
                                                        key={frm.id + rstIndex}
                                                        objectTrpls={objectTrpls}
                                                        formId={this.state.formId}
                                                        concept={groupParentConcept}
                                                        mainFormNodeId={groupParentIndividual}
                                                        saveOnlyForm={saveOnlyForm}
                                                        getTrplNode={this.getTrplNode}
                                                        optionalFields={optionalFields}
                                                        submitOnlyForm={submitOnlyForm}
                                                        accordeonRstData={accordeonRstData}
                                                        getRstMetaData={this.getRstMetaData}
                                                        onRstValueEdit={this.onRstValueEdit}
                                                        showOptionalRst={this.showOptionalRst}
                                                        removeTrplValue={this.removeTrplValue}
                                                        getRstTrplsData={this.getRstTrplsData}
                                                        onNodeRemoveClick={this.onNodeRemoveClick}
                                                        onRstTypeBtnClick={this.onRstTypeBtnClick}
                                                        optionalFieldsOptions={optionalFieldsOptions}
                                                        accordeonRestrictions={accordeonRestrictions}
                                                        openObjectEditModal={this.openObjectEditModal}
                                                        removeAccordeonNode={this.removeAccordeonNode}
                                                        isDisableTrplEditing={this.isDisableTrplEditing}
                                                        getAutocompleteTrpls={this.getAutocompleteTrpls}
                                                        onAccordeonEditClick={this.onAccordeonEditClick}
                                                        toggleUploadImgModal={this.toggleUploadImgModal}
                                                        onChangeTextereaHeight={this.onChangeTextereaHeight}
                                                        onAddNewAccordeonClick={this.onAddNewAccordeonClick}
                                                        updateDataOnRestoreTrpl={this.updateDataOnRestoreTrpl}
                                                        openTrplRenderPartsModal={this.openTrplRenderPartsModal}
                                                        onAccordeonAddNewNodeClick={this.onAccordeonAddNewNodeClick}
                                                        onWidgetCheckboxesValueEdit={this.onWidgetCheckboxesValueEdit}
                                                        onNodeAddDropdownElementClick={
                                                          this.onNodeAddDropdownElementClick
                                                        }
                                                      />
                                                    );
                                                  }

                                                  if (rst.type === 'function') {
                                                    return (
                                                      <FunctionRenderer
                                                        rst={rst}
                                                        key={rstIndex}
                                                        form_funcs={data.form_funcs || ''}
                                                        groupArrIndex={groupArrIndex}
                                                        rstIndex={rstIndex}
                                                        groupIndex={groupIndex}
                                                      />
                                                    );
                                                  }

                                                  let rstData = this.getRstTrplsData(item, rst, parentIndividual, parentConcept);
                                                  const isCustom = rst && rst.type === 'custom';
                                                  if (!rstData && !isCustom) return null;
                                                  if (isCustom) rst = cloneDeep(rst);

                                                  return (
                                                    <TrplFormRow
                                                      rst={rst}
                                                      data={data}
                                                      mode={mode}
                                                      item={item}
                                                      isGroup={true}
                                                      key={rstIndex}
                                                      classes={classes}
                                                      rstData={rstData}
                                                      groupId={groupId}
                                                      isNewNode={isNewNode}
                                                      concept={parentConcept}
                                                      formId={this.state.formId}
                                                      saveOnlyForm={saveOnlyForm}
                                                      ancestorId={parentIndividual}
                                                      getTrplNode={this.getTrplNode}
                                                      submitOnlyForm={submitOnlyForm}
                                                      getRstMetaData={this.getRstMetaData}
                                                      getRstTrplsData={this.getRstTrplsData}
                                                      removeAccordeonNode={this.removeAccordeonNode}
                                                      isDisableTrplEditing={this.isDisableTrplEditing}
                                                      getAutocompleteTrpls={this.getAutocompleteTrpls}
                                                      openObjectEditModal={this.openObjectEditModal}
                                                      onChangeTextereaHeight={this.onChangeTextereaHeight}
                                                      openTrplRenderPartsModal={this.openTrplRenderPartsModal}
                                                      onAccordeonAddNewNodeClick={this.onAccordeonAddNewNodeClick}
                                                      isAnotherNode={Array.isArray(rst.id) && rst.id.length > 0}
                                                      updateDataOnRestoreTrpl={this.updateDataOnRestoreTrpl}
                                                      toggleUploadImgModal={this.toggleUploadImgModal}
                                                      onRstValueEdit={this.onRstValueEdit}
                                                      onRstTypeBtnClick={this.onRstTypeBtnClick}
                                                      removeTrplValue={this.removeTrplValue}
                                                      setTrpl={this.setTrpl}
                                                      onNodeRemoveClick={this.onNodeRemoveClick}
                                                      onNodeAddDropdownElementClick={
                                                        this.onNodeAddDropdownElementClick
                                                      }
                                                      onWidgetCheckboxesValueEdit={
                                                        this.onWidgetCheckboxesValueEdit
                                                      }
                                                    />
                                                  );
                                                })
                                              : null}
                                          </TableBody>
                                        </Table>

                                        {group.type !== 'accordeon' && optionalFieldsOptions.length ? (
                                          <div
                                            style={{
                                              width: '130px',
                                              padding: '5px 10px 10px 10px',
                                            }}
                                          >
                                            <TrplSelect
                                              margin="none"
                                              complicatedValues
                                              disalbeItalicPlaceholder
                                              placeholder="Optional"
                                              value={optionalFields[groupId].selectValue}
                                              values={optionalFieldsOptions}
                                              onChange={(e) => {
                                                this.showOptionalRst(e.target.value, groupId);
                                              }}
                                            />
                                          </div>
                                        ) : null}
                                      </div>
                                    ) : null}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                      </div>
                    ) : concepts.length ? (
                      concepts.map((concept, conceptIndex) => {
                        return [
                          isSearchByRst && !conceptIndex && this.isIndividualOrNodeWithPredicates() && (
                            <TableRow key={`${concept.id}.${conceptIndex}`}>
                              <TableCell
                                colSpan={2}
                                style={{
                                  borderBottom: 'none',
                                  padding: '0 10px 10px 0',
                                }}
                              >
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <Search
                                    className={classes.predicateSearchIcon}
                                  />
                                  <input
                                    id={'predicateSearch'}
                                    autoFocus
                                    value={searchedRst ? searchedRst : ''}
                                    placeholder={'Search by predicates'}
                                    className={classes.predicateSearch}
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      this.setState({
                                        filteringRst: true,
                                        searchedRst: value,
                                      }, () => {
                                        setTimeout(() => {
                                          this.onSearchRst(value);
                                          this.setState({ filteringRst: false });
                                        });
                                      });
                                    }}
                                  />
                                  {filteringRst
                                    ? <LoaderNew style={{ marginLeft: '-30px' }}/>
                                    : searchedRst &&
                                    <Clear
                                      className={classes.predicateSearchClear}
                                      onClick={() => {
                                        const predicateSearch = document.getElementById('predicateSearch');
                                        if (predicateSearch) predicateSearch.value = '';

                                        this.setState({
                                          filteringRst: true,
                                          searchedRst: null,
                                        }, () => {
                                          setTimeout(() => {
                                            this.onSearchRst();
                                            this.setState({ filteringRst: false });
                                          });
                                        });
                                      }}
                                    />
                                  }
                                </div>
                              </TableCell>
                            </TableRow>
                          ),

                          !concept.isTitle && !concept.isNPred && concept.restrictions.length && (!groups || !groups.length) ? (
                            <TableRow key={conceptIndex}>
                              <StyledCell
                                style={{
                                  border: 'none',
                                  paddingTop: '15px',
                                  paddingBottom: '5px',
                                }}
                              >
                                {data.nodes && data.nodes[concept.id] ? (
                                  <Node isLink
                                    size="md"
                                    nodes={data.nodes}
                                    nodeId={concept.id}
                                    node={data.nodes[concept.id]}
                                  />
                                ) : null}
                              </StyledCell>

                              <StyledCell style={{ border: 'none' }} />
                              <StyledCell style={{ border: 'none' }} />
                            </TableRow>
                          ) : null,

                          concept.restrictions.map((rst, rstIndex) => {
                            const rstData = this.getRstTrplsData(null, rst, null, concept.id);

                            return (
                              <TrplFormRow
                                rst={rst}
                                data={data}
                                mode={mode}
                                key={rstIndex}
                                isGroup={false}
                                classes={classes}
                                rstData={rstData}
                                concept={concept.id}
                                isNewNode={isNewNode}
                                ancestorId={ancestorId}
                                setTrpl={this.setTrpl}
                                getRstMetaData={this.getRstMetaData}
                                onRstValueEdit={this.onRstValueEdit}
                                removeTrplValue={this.removeTrplValue}
                                onRstTypeBtnClick={this.onRstTypeBtnClick}
                                onNodeRemoveClick={this.onNodeRemoveClick}
                                getAutocompleteTrpls={this.getAutocompleteTrpls}
                                toggleUploadImgModal={this.toggleUploadImgModal}
                                onChangeTextereaHeight={this.onChangeTextereaHeight}
                                updateDataOnRestoreTrpl={this.updateDataOnRestoreTrpl}
                                openTrplRenderPartsModal={this.openTrplRenderPartsModal}
                                onNodeAddDropdownElementClick={this.onNodeAddDropdownElementClick}
                              />
                            );
                          }),
                        ];
                      })
                    ) : null}
                  </TableBody>
                </Table>

                {isGroups && tabs && tabs.length && (tabs.length > 1) ? (
                  <div className={`${classes.spaceBetween} ${classes.mt20}`}>
                    {tab !== tabs[0] ?
                    <Button onClick={() => this.goToChangeTab('back')} className={classes.circleBtn}>
                      <ArrowBackIosNewOutlined style={{ fontSize: 12, marginRight: '10px' }}/>
                      {`${tabs[tabs.indexOf(tab) - 1]}`}
                    </Button> : <div/>}
                    {tab !== tabs[tabs.length - 1] ?
                    <Button onClick={() => this.goToChangeTab('next')} className={classes.circleBtn}>
                      {`${tabs[tabs.indexOf(tab) + 1]}`}
                      <ArrowForwardIosOutlined style={{ fontSize: 12, marginLeft: '10px' }}/>
                    </Button> : <div/>}
                  </div>
                ) : null}

                {mode !== 'view' && submitOnlyForm ? (
                  <div className={`${classes.justifyCenter} ${classes.mt20}`}>
                    {disableSaveBtn ? null : (
                      <Button
                        size="small"
                        disabled={saveBtnLoading}
                        onClick={() => {
                          this.setState({
                            saveBtnLoading: true
                          }, () => this.onSaveTrplsClick()
                        )}}
                        className={`${classes.btnBig} ${classes.btnBigNormal}`}
                      >
                        {saveBtnLoading ? <LoaderNew color='#FFF'/> : saveBtnText}
                      </Button>
                    )}
                  </div>
                ) : null}
              </Paper>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const styles = { ...CommonStyles, ...TrplFormStyles };

const WrappedTrplForm = connect((state) => ({
  jels: state.jels,
  setup: state.meta.setup,
}), { updateJelsFromGetView, getJelData })(withStyles(styles)(TrplForm));

export default WrappedTrplForm;
